const singleBabyData = {
  version: 1,
  lang: "kr",

  datas: [
    {
      week: 0,
      baby: {
        head: {
          title: "건강하게 수정중!",
          discribed: "",
          size: "0.1mm 미만",
        },
        body: [
          {
            subTitle: "정자와 난자의 만남",
            discribed:
              "임신 1주차에는 난자와 정자가 나팔관 내에서 만나 수정을 하면서 생명이 시작돼요!\n\n수정이 이루어진 후 12~15시간이 지나면 수정란은 세포분열을 하기 시작하는데, 수정란의 크기는 지름 0.2cm 정도로 아주 작아요.\n\n이 시기에는 아직 태아가 아니라 배아라고 부르는 시기예요.\n\n배아란 수정란이 세포분열을 반복해 하나의 완전한 개체인 태아가 되기 전까지를 의미하며, 임신 8주 이전까지는 배아라고 부르게 된답니다.\n\n임신 2주 경에는 수정란이 세포분열을 반복하여 나팔관을 따라 자궁으로 이동해요.\n\n수정 후 7~10일이 지나면 수정란은 자궁내막에 착상을 해요!",
          },
        ],
      },
      mom: {
        head: {
          title: "몸이 으슬으슬, 감기가 아니에요!",
          discribed: "호르몬 분비로 몸에 변화가 생기고 있어요!",
        },
        body: [
          {
            subTitle: "배란을 준비해요!",
            discribed:
              "임신 1주 차는 임신이 된 상태라기보다는 임신이 되기 전 마지막 생리 기간, 임신을 위해 배란을 준비하는 시간이라고 볼 수 있어요!\n\n수정란이 수정된 지 12시간에서 15시간 정도 지나면 세포분열을 하는데 이 시기를 임신 1주라고 해요.\n\n이 시기는 정자와 난자가 만나 수정은 이루어졌지만 자궁 내로 착상은 이루어지지 않은 상태인데, 엄마의 몸에 아직 눈에띄게 큰 변화는 없어요.\n\n임신 2주차에는 자궁벽이 푹신해지거나 두꺼워지고, 초기의 태아를 자궁점막에 착상되기 쉬운 상태로 만들기 위해 황체호르몬이 계속 분비돼요.",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "임신 1~2주차에는 임신 사실을 알아채기 힘들고, 거의 아무런 증상을 느끼지 못하는 경우가 대부분이지만 예민한 엄마들에게는 약간의 증상이 있을 수 있어요.\n\n가장 먼저 확인할 수 있는 신호는 생리를 하지 않는다는 거예요!\n\n생리가 생리 예정 날짜보다 일주일 정도 늦어진다면 임신을 의심할 수 있어요.\n\n또 체온이 오르고 몸이 으슬으슬 떨리는 등, 감기와 유사한 증상이 느껴질 수 있어요.\n\n평소보다 몸이 나른하고 이유 없이 쉽게 피곤해지며 잠이 늘기도 해요.\n\n임신을 준비중인 예비엄마라면, 태아의 건강을 위해서 각별한 주의와 세심한 케어가 필요하겠죠?\n\n엄마의 몸에서 일어나는 사소한 변화들을 놓치지 않도록 주의깊게 살펴봐요.",
          },
          {
            subTitle: "예비엄마라면 조심해요!",
            discribed:
              "음주와 흡연은 멀리 하고, 약을 먹는것도 조심해야 해요.\n\n유해환경에 노출되지 않는것도 아주 중요하구요.\n\n뱃속의 태아는 엄마에게서 영양분과 산소 등 모든 것을 받고 있기 때문에 태아의 건강을 위해서는 각별한 주의가 필요하답니다.\n\n특히 임신 초기에는 큰 증상이 없어 임신 사실을 모르는 경우도 많기 때문에, 임신을 준비중인 예비 엄마라면 배란기 이후 뿐 아니라 평상시에도 신경쓸 수 있도록 노력해봐요!",
          },
          {
            subTitle: "어떤 영양소가 중요할까요?",
            discribed:
              "많이들 알고 계시듯이 엽산은 임신부에게 특히 중요한 비타민이에요!\n\n엽산이 부족하면 빈혈, 백혈구의 변화, 신경관 결손 같은 태아 기형을 유발될 수 있어요.\n\n따라서 하루 0.4mg씩 꾸준히 섭취하는 것을 추천해요.\n\n현미, 녹황색 채소, 오렌지, 치즈, 특히 키위는 엽산이 풍부하게 함유되어있는 식품이이랍니다!\n\n하지만 엽산은 조리 과정중 파괴되기 쉬운 영양소이니마큼 보충제를 챙겨 먹는 것이 좋아요.\n\n또다른 중요한 영양소로는 비타민 D가 있어요.\n\n비타민D는 엄마와 태아의 뼈 건강과 면역력에 중요할 뿐 아니라, 임신중독증에도 도움이 돼요.\n\n비타민D가 결핍될 경우 임신성 고혈압, 전자간증의 확률이 높아질 수 있어요.\n\n사실 비타민D는 낮에 햇빛만 잘 받아도 충분히 생성되지만, 햇빛을 충분히 보지 못하는 현대인들은 평소에도 비타민D가 부족한 경우가 많아요.\n\n따라서 비타민D가 풍부한 달걀 노른자, 고등어, 연어, 유제품 등을 충분히 섭취하거나, 영양제를 따로 챙겨먹는 것을 추천드려요.",
          },
          {
            subTitle: "임신기간은 어떻게 계산할까요?",
            discribed:
              "출산 예정일에 정확히 출산할 확률은 매우 낮지만 출산 예정일을 알면 태아의 건강 상태를 체크하고 계획적인 출산 준비를 하는 데 큰 도움이 되겠죠?\n\n임신 기간을 계산할 때에는 수정일이나 마지막 월경기간을 이용하는데, 정확한 수정일은 파악하기 어렵기 때문에 주로 마지막 월경기간을 사용해요.\n\n그렇기 때문에 임신을 계획중이라면 월경 기간을 꼼꼼히 기록해 두는 것이 좋답니다.\n\n태아가 모체 내에 있는 기간이 항상 일정한 것은 아니지만, 대체로 최초생리일로 부터 280일, 즉 4주간(26일)을 1개월로 본 40주(10개월)를 임신기간으로 봐요.\n\n그래서 마지막으로 월경을 마친 달수에서 3을 빼거나, 그 달의 숫자가 작아 3을 뺄수 잆을 때에는 9를 더한 것이 아기가 나올 '달' 이에요.\n\n그런 다음 마지막으로 월경의 첫 날에 7일 더한 것이 분만 예정일이 되죠.\n\n예를 들어마지막 생리 시작일이 10월 7일인 경우 10 - 3 = 7, 7 + 7 = 14 그러므로 분만 예정일은 7월 14일이 되는 거예요.",
          },
        ],
      },
      dad: {
        head: {
          title: "건강한 임신을 위해 아빠도 함께 노력해요!",
          discribed: "40주간의 여정을 함께해봐요!",
        },
        body: [
          {
            subTitle: "건강한 정자를 위한 3개월!",
            discribed:
              "건강한 임신을 위해 건강한 정자를 만드려면 적어도 3개월 이상의 준비기간이 필요해요.\n\n정자가 만들어져 밖으로 나오기까지 총 3개월이 걸리기 때문이에요.\n\n그렇다면 건강한 정자를 위해서는 어떤 노력이 필요할까요?\n\n- 규칙적이고 충분한 수면\n\n정자 형성에 중요한 역할을 하는 난포자극호르몬(FSH), 황체형성호르몬(LH)과 남성호르몬은 낮에 증가하고 밤에 감소해요.\n\n그런데 밤낮이 바뀐 생활을 하거나 오랫동안 수면이 부족하다면 호르몬 분비가 원활하지 못해 정자의 질을 떨어뜨리게 되겠죠?\n\n건강한 정자를 위해서는 낮에 활동하고 밤에 자는 규칙적인 생활을 하고, 충분한 수면을 취하는 것이 중요하답니다.\n\n- 건강한 정자를 위한 영양소 섭취\n\n아연,셀레늄 등의 영양소를 보충하면 정자의 여러 지표가 개선되는 효과를 얻을 수 있어요!\n\n아연은 정액의 양과 운동성에 좋으며 육류나 조개류, 유제품군에 풍부해요.\n\n셀레늄은 정자의 질을 향상시키는데 도움이 돼요.\n\n셀레늄은 브라질너트, 어류, 율규 달걀에 풍부하게 포함되어 있답니다.\n\n식품에서의 섭취가 어렵다면 영양제를 통해 보충하는 것도 좋은 방법이에요.\n\n- 술·담배 금지\n\n흡연은 체내 활성화 산소를 증가시켜 정자의 기능을 감소시키고 정자 핵의 DNA를 손상시켜 난임을 유발해요.\n\n또 알코올 섭취로 남성호르몬 및 정자 형성에 부정적인 영향을 끼쳐요.\n\n임신을 계획중인 예비 아빠라면 금연과 금주, 미리미리 준비해봐요!\n\n- 고환온도 낮게 유지\n\n고환에서 정자가 만들어질 때, 또 정자가 부고환이나 정관을 통해 이동할 때 고환의 온도가 오르면 정자의 수 뿐만 아니라 운동성과 모양에도 나쁜 영향을 줘요.\n\n고환의 온도가 높아지는 것을 막으려면 사우나, 찜질방, 빈번한 반신욕 등의 상황은 가급적 피하도록 해요.\n\n몸을 조이는 속옷이나 바지는 입지 말고, 너무 오래 앉아 있거나 다리를 꼬고 앉는 자세도 좋지 않답니다.",
          },
          {
            subTitle:
              "임신은 부부가 함께 달리는 마라톤, 지금부터 같이 준비해요!",
            discribed:
              "임신기간을 잘 보내기 위해서는 엄마와 아빠의 협동이 중요해요.\n\n두 사람이 함께하는 긴 레이스가 이제 막 시작됐어요!\n\n옳은 길을 선택하고, 바른 자세로 달릴 수 있도록 멋진 페이스메이커가 되어주세요.\n\n그러기 위해서는 서로를 깊이 이해하고 앞으로의 여정에 대해 잘 알아야겠죠?\n\n마음을 터놓는 깊은 대화를 나누고, 임신에 대해 공부해가며 새로운 가족을 맞이하기 위한 40주의 대장정을 함께 달려봐요!",
          },
        ],
      },
    },
    {
      week: 1,
      baby: {
        head: {
          title: "건강하게 수정중!",
          discribed: "",
          size: "0.1mm 미만",
        },
        body: [
          {
            subTitle: "정자와 난자의 만남",
            discribed:
              "임신 1주차에는 난자와 정자가 나팔관 내에서 만나 수정을 하면서 생명이 시작돼요!\n\n수정이 이루어진 후 12~15시간이 지나면 수정란은 세포분열을 하기 시작하는데, 수정란의 크기는 지름 0.2cm 정도로 아주 작아요.\n\n이 시기에는 아직 태아가 아니라 배아라고 부르는 시기예요.\n\n배아란 수정란이 세포분열을 반복해 하나의 완전한 개체인 태아가 되기 전까지를 의미하며, 임신 8주 이전까지는 배아라고 부르게 된답니다.\n\n임신 2주 경에는 수정란이 세포분열을 반복하여 나팔관을 따라 자궁으로 이동해요.\n\n수정 후 7~10일이 지나면 수정란은 자궁내막에 착상을 해요!",
          },
        ],
      },
      mom: {
        head: {
          title: "몸이 으슬으슬, 감기가 아니에요!",
          discribed: "호르몬 분비로 몸에 변화가 생기고 있어요!",
        },
        body: [
          {
            subTitle: "배란을 준비해요!",
            discribed:
              "임신 1주 차는 임신이 된 상태라기보다는 임신이 되기 전 마지막 생리 기간, 임신을 위해 배란을 준비하는 시간이라고 볼 수 있어요!\n\n수정란이 수정된 지 12시간에서 15시간 정도 지나면 세포분열을 하는데 이 시기를 임신 1주라고 해요.\n\n이 시기는 정자와 난자가 만나 수정은 이루어졌지만 자궁 내로 착상은 이루어지지 않은 상태인데, 엄마의 몸에 아직 눈에띄게 큰 변화는 없어요.\n\n임신 2주차에는 자궁벽이 푹신해지거나 두꺼워지고, 초기의 태아를 자궁점막에 착상되기 쉬운 상태로 만들기 위해 황체호르몬이 계속 분비돼요.",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "임신 1~2주차에는 임신 사실을 알아채기 힘들고, 거의 아무런 증상을 느끼지 못하는 경우가 대부분이지만 예민한 엄마들에게는 약간의 증상이 있을 수 있어요.\n\n가장 먼저 확인할 수 있는 신호는 생리를 하지 않는다는 거예요!\n\n생리가 생리 예정 날짜보다 일주일 정도 늦어진다면 임신을 의심할 수 있어요.\n\n또 체온이 오르고 몸이 으슬으슬 떨리는 등, 감기와 유사한 증상이 느껴질 수 있어요.\n\n평소보다 몸이 나른하고 이유 없이 쉽게 피곤해지며 잠이 늘기도 해요.\n\n임신을 준비중인 예비엄마라면, 태아의 건강을 위해서 각별한 주의와 세심한 케어가 필요하겠죠?\n\n엄마의 몸에서 일어나는 사소한 변화들을 놓치지 않도록 주의깊게 살펴봐요.",
          },
          {
            subTitle: "예비엄마라면 조심해요!",
            discribed:
              "음주와 흡연은 멀리 하고, 약을 먹는것도 조심해야 해요.\n\n유해환경에 노출되지 않는것도 아주 중요하구요.\n\n뱃속의 태아는 엄마에게서 영양분과 산소 등 모든 것을 받고 있기 때문에 태아의 건강을 위해서는 각별한 주의가 필요하답니다.\n\n특히 임신 초기에는 큰 증상이 없어 임신 사실을 모르는 경우도 많기 때문에, 임신을 준비중인 예비 엄마라면 배란기 이후 뿐 아니라 평상시에도 신경쓸 수 있도록 노력해봐요!",
          },
          {
            subTitle: "어떤 영양소가 중요할까요?",
            discribed:
              "많이들 알고 계시듯이 엽산은 임신부에게 특히 중요한 비타민이에요!\n\n엽산이 부족하면 빈혈, 백혈구의 변화, 신경관 결손 같은 태아 기형을 유발될 수 있어요.\n\n따라서 하루 0.4mg씩 꾸준히 섭취하는 것을 추천해요.\n\n현미, 녹황색 채소, 오렌지, 치즈, 특히 키위는 엽산이 풍부하게 함유되어있는 식품이이랍니다!\n\n하지만 엽산은 조리 과정중 파괴되기 쉬운 영양소이니마큼 보충제를 챙겨 먹는 것이 좋아요.\n\n또다른 중요한 영양소로는 비타민 D가 있어요.\n\n비타민D는 엄마와 태아의 뼈 건강과 면역력에 중요할 뿐 아니라, 임신중독증에도 도움이 돼요.\n\n비타민D가 결핍될 경우 임신성 고혈압, 전자간증의 확률이 높아질 수 있어요.\n\n사실 비타민D는 낮에 햇빛만 잘 받아도 충분히 생성되지만, 햇빛을 충분히 보지 못하는 현대인들은 평소에도 비타민D가 부족한 경우가 많아요.\n\n따라서 비타민D가 풍부한 달걀 노른자, 고등어, 연어, 유제품 등을 충분히 섭취하거나, 영양제를 따로 챙겨먹는 것을 추천드려요.",
          },
          {
            subTitle: "임신기간은 어떻게 계산할까요?",
            discribed:
              "출산 예정일에 정확히 출산할 확률은 매우 낮지만 출산 예정일을 알면 태아의 건강 상태를 체크하고 계획적인 출산 준비를 하는 데 큰 도움이 되겠죠?\n\n임신 기간을 계산할 때에는 수정일이나 마지막 월경기간을 이용하는데, 정확한 수정일은 파악하기 어렵기 때문에 주로 마지막 월경기간을 사용해요.\n\n그렇기 때문에 임신을 계획중이라면 월경 기간을 꼼꼼히 기록해 두는 것이 좋답니다.\n\n태아가 모체 내에 있는 기간이 항상 일정한 것은 아니지만, 대체로 최초생리일로 부터 280일, 즉 4주간(26일)을 1개월로 본 40주(10개월)를 임신기간으로 봐요.\n\n그래서 마지막으로 월경을 마친 달수에서 3을 빼거나, 그 달의 숫자가 작아 3을 뺄수 잆을 때에는 9를 더한 것이 아기가 나올 '달' 이에요.\n\n그런 다음 마지막으로 월경의 첫 날에 7일 더한 것이 분만 예정일이 되죠.\n\n예를 들어마지막 생리 시작일이 10월 7일인 경우 10 - 3 = 7, 7 + 7 = 14 그러므로 분만 예정일은 7월 14일이 되는 거예요.",
          },
        ],
      },
      dad: {
        head: {
          title: "건강한 임신을 위해 아빠도 함께 노력해요!",
          discribed: "40주간의 여정을 함께해봐요!",
        },
        body: [
          {
            subTitle: "건강한 정자를 위한 3개월!",
            discribed:
              "건강한 임신을 위해 건강한 정자를 만드려면 적어도 3개월 이상의 준비기간이 필요해요.\n\n정자가 만들어져 밖으로 나오기까지 총 3개월이 걸리기 때문이에요.\n\n그렇다면 건강한 정자를 위해서는 어떤 노력이 필요할까요?\n\n- 규칙적이고 충분한 수면\n\n정자 형성에 중요한 역할을 하는 난포자극호르몬(FSH), 황체형성호르몬(LH)과 남성호르몬은 낮에 증가하고 밤에 감소해요.\n\n그런데 밤낮이 바뀐 생활을 하거나 오랫동안 수면이 부족하다면 호르몬 분비가 원활하지 못해 정자의 질을 떨어뜨리게 되겠죠?\n\n건강한 정자를 위해서는 낮에 활동하고 밤에 자는 규칙적인 생활을 하고, 충분한 수면을 취하는 것이 중요하답니다.\n\n- 건강한 정자를 위한 영양소 섭취\n\n아연,셀레늄 등의 영양소를 보충하면 정자의 여러 지표가 개선되는 효과를 얻을 수 있어요!\n\n아연은 정액의 양과 운동성에 좋으며 육류나 조개류, 유제품군에 풍부해요.\n\n셀레늄은 정자의 질을 향상시키는데 도움이 돼요.\n\n셀레늄은 브라질너트, 어류, 율규 달걀에 풍부하게 포함되어 있답니다.\n\n식품에서의 섭취가 어렵다면 영양제를 통해 보충하는 것도 좋은 방법이에요.\n\n- 술·담배 금지\n\n흡연은 체내 활성화 산소를 증가시켜 정자의 기능을 감소시키고 정자 핵의 DNA를 손상시켜 난임을 유발해요.\n\n또 알코올 섭취로 남성호르몬 및 정자 형성에 부정적인 영향을 끼쳐요.\n\n임신을 계획중인 예비 아빠라면 금연과 금주, 미리미리 준비해봐요!\n\n- 고환온도 낮게 유지\n\n고환에서 정자가 만들어질 때, 또 정자가 부고환이나 정관을 통해 이동할 때 고환의 온도가 오르면 정자의 수 뿐만 아니라 운동성과 모양에도 나쁜 영향을 줘요.\n\n고환의 온도가 높아지는 것을 막으려면 사우나, 찜질방, 빈번한 반신욕 등의 상황은 가급적 피하도록 해요.\n\n몸을 조이는 속옷이나 바지는 입지 말고, 너무 오래 앉아 있거나 다리를 꼬고 앉는 자세도 좋지 않답니다.",
          },
          {
            subTitle:
              "임신은 부부가 함께 달리는 마라톤, 지금부터 같이 준비해요!",
            discribed:
              "임신기간을 잘 보내기 위해서는 엄마와 아빠의 협동이 중요해요.\n\n두 사람이 함께하는 긴 레이스가 이제 막 시작됐어요!\n\n옳은 길을 선택하고, 바른 자세로 달릴 수 있도록 멋진 페이스메이커가 되어주세요.\n\n그러기 위해서는 서로를 깊이 이해하고 앞으로의 여정에 대해 잘 알아야겠죠?\n\n마음을 터놓는 깊은 대화를 나누고, 임신에 대해 공부해가며 새로운 가족을 맞이하기 위한 40주의 대장정을 함께 달려봐요!",
          },
        ],
      },
    },
    {
      week: 2,
      baby: {
        head: {
          title: "건강하게 수정중!",
          discribed: "",
          size: "0.1mm 미만",
        },
        body: [
          {
            subTitle: "정자와 난자의 만남",
            discribed:
              "임신 1주차에는 난자와 정자가 나팔관 내에서 만나 수정을 하면서 생명이 시작돼요!\n\n수정이 이루어진 후 12~15시간이 지나면 수정란은 세포분열을 하기 시작하는데, 수정란의 크기는 지름 0.2cm 정도로 아주 작아요.\n\n이 시기에는 아직 태아가 아니라 배아라고 부르는 시기예요.\n\n배아란 수정란이 세포분열을 반복해 하나의 완전한 개체인 태아가 되기 전까지를 의미하며, 임신 8주 이전까지는 배아라고 부르게 된답니다.\n\n임신 2주 경에는 수정란이 세포분열을 반복하여 나팔관을 따라 자궁으로 이동해요.\n\n수정 후 7~10일이 지나면 수정란은 자궁내막에 착상을 해요!",
          },
        ],
      },
      mom: {
        head: {
          title: "몸이 으슬으슬, 감기가 아니에요!",
          discribed: "호르몬 분비로 몸에 변화가 생기고 있어요!",
        },
        body: [
          {
            subTitle: "배란을 준비해요!",
            discribed:
              "임신 1주 차는 임신이 된 상태라기보다는 임신이 되기 전 마지막 생리 기간, 임신을 위해 배란을 준비하는 시간이라고 볼 수 있어요!\n\n수정란이 수정된 지 12시간에서 15시간 정도 지나면 세포분열을 하는데 이 시기를 임신 1주라고 해요.\n\n이 시기는 정자와 난자가 만나 수정은 이루어졌지만 자궁 내로 착상은 이루어지지 않은 상태인데, 엄마의 몸에 아직 눈에띄게 큰 변화는 없어요.\n\n임신 2주차에는 자궁벽이 푹신해지거나 두꺼워지고, 초기의 태아를 자궁점막에 착상되기 쉬운 상태로 만들기 위해 황체호르몬이 계속 분비돼요.",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "임신 1~2주차에는 임신 사실을 알아채기 힘들고, 거의 아무런 증상을 느끼지 못하는 경우가 대부분이지만 예민한 엄마들에게는 약간의 증상이 있을 수 있어요.\n\n가장 먼저 확인할 수 있는 신호는 생리를 하지 않는다는 거예요!\n\n생리가 생리 예정 날짜보다 일주일 정도 늦어진다면 임신을 의심할 수 있어요.\n\n또 체온이 오르고 몸이 으슬으슬 떨리는 등, 감기와 유사한 증상이 느껴질 수 있어요.\n\n평소보다 몸이 나른하고 이유 없이 쉽게 피곤해지며 잠이 늘기도 해요.\n\n임신을 준비중인 예비엄마라면, 태아의 건강을 위해서 각별한 주의와 세심한 케어가 필요하겠죠?\n\n엄마의 몸에서 일어나는 사소한 변화들을 놓치지 않도록 주의깊게 살펴봐요.",
          },
          {
            subTitle: "예비엄마라면 조심해요!",
            discribed:
              "음주와 흡연은 멀리 하고, 약을 먹는것도 조심해야 해요.\n\n유해환경에 노출되지 않는것도 아주 중요하구요.\n\n뱃속의 태아는 엄마에게서 영양분과 산소 등 모든 것을 받고 있기 때문에 태아의 건강을 위해서는 각별한 주의가 필요하답니다.\n\n특히 임신 초기에는 큰 증상이 없어 임신 사실을 모르는 경우도 많기 때문에, 임신을 준비중인 예비 엄마라면 배란기 이후 뿐 아니라 평상시에도 신경쓸 수 있도록 노력해봐요!",
          },
          {
            subTitle: "어떤 영양소가 중요할까요?",
            discribed:
              "많이들 알고 계시듯이 엽산은 임신부에게 특히 중요한 비타민이에요!\n\n엽산이 부족하면 빈혈, 백혈구의 변화, 신경관 결손 같은 태아 기형을 유발될 수 있어요.\n\n따라서 하루 0.4mg씩 꾸준히 섭취하는 것을 추천해요.\n\n현미, 녹황색 채소, 오렌지, 치즈, 특히 키위는 엽산이 풍부하게 함유되어있는 식품이이랍니다!\n\n하지만 엽산은 조리 과정중 파괴되기 쉬운 영양소이니마큼 보충제를 챙겨 먹는 것이 좋아요.\n\n또다른 중요한 영양소로는 비타민 D가 있어요.\n\n비타민D는 엄마와 태아의 뼈 건강과 면역력에 중요할 뿐 아니라, 임신중독증에도 도움이 돼요.\n\n비타민D가 결핍될 경우 임신성 고혈압, 전자간증의 확률이 높아질 수 있어요.\n\n사실 비타민D는 낮에 햇빛만 잘 받아도 충분히 생성되지만, 햇빛을 충분히 보지 못하는 현대인들은 평소에도 비타민D가 부족한 경우가 많아요.\n\n따라서 비타민D가 풍부한 달걀 노른자, 고등어, 연어, 유제품 등을 충분히 섭취하거나, 영양제를 따로 챙겨먹는 것을 추천드려요.",
          },
          {
            subTitle: "임신기간은 어떻게 계산할까요?",
            discribed:
              "출산 예정일에 정확히 출산할 확률은 매우 낮지만 출산 예정일을 알면 태아의 건강 상태를 체크하고 계획적인 출산 준비를 하는 데 큰 도움이 되겠죠?\n\n임신 기간을 계산할 때에는 수정일이나 마지막 월경기간을 이용하는데, 정확한 수정일은 파악하기 어렵기 때문에 주로 마지막 월경기간을 사용해요.\n\n그렇기 때문에 임신을 계획중이라면 월경 기간을 꼼꼼히 기록해 두는 것이 좋답니다.\n\n태아가 모체 내에 있는 기간이 항상 일정한 것은 아니지만, 대체로 최초생리일로 부터 280일, 즉 4주간(26일)을 1개월로 본 40주(10개월)를 임신기간으로 봐요.\n\n그래서 마지막으로 월경을 마친 달수에서 3을 빼거나, 그 달의 숫자가 작아 3을 뺄수 잆을 때에는 9를 더한 것이 아기가 나올 '달' 이에요.\n\n그런 다음 마지막으로 월경의 첫 날에 7일 더한 것이 분만 예정일이 되죠.\n\n예를 들어마지막 생리 시작일이 10월 7일인 경우 10 - 3 = 7, 7 + 7 = 14 그러므로 분만 예정일은 7월 14일이 되는 거예요.",
          },
        ],
      },
      dad: {
        head: {
          title: "건강한 임신을 위해 아빠도 함께 노력해요!",
          discribed: "40주간의 여정을 함께해봐요!",
        },
        body: [
          {
            subTitle: "건강한 정자를 위한 3개월!",
            discribed:
              "건강한 임신을 위해 건강한 정자를 만드려면 적어도 3개월 이상의 준비기간이 필요해요.\n\n정자가 만들어져 밖으로 나오기까지 총 3개월이 걸리기 때문이에요.\n\n그렇다면 건강한 정자를 위해서는 어떤 노력이 필요할까요?\n\n- 규칙적이고 충분한 수면\n\n정자 형성에 중요한 역할을 하는 난포자극호르몬(FSH), 황체형성호르몬(LH)과 남성호르몬은 낮에 증가하고 밤에 감소해요.\n\n그런데 밤낮이 바뀐 생활을 하거나 오랫동안 수면이 부족하다면 호르몬 분비가 원활하지 못해 정자의 질을 떨어뜨리게 되겠죠?\n\n건강한 정자를 위해서는 낮에 활동하고 밤에 자는 규칙적인 생활을 하고, 충분한 수면을 취하는 것이 중요하답니다.\n\n- 건강한 정자를 위한 영양소 섭취\n\n아연,셀레늄 등의 영양소를 보충하면 정자의 여러 지표가 개선되는 효과를 얻을 수 있어요!\n\n아연은 정액의 양과 운동성에 좋으며 육류나 조개류, 유제품군에 풍부해요.\n\n셀레늄은 정자의 질을 향상시키는데 도움이 돼요.\n\n셀레늄은 브라질너트, 어류, 율규 달걀에 풍부하게 포함되어 있답니다.\n\n식품에서의 섭취가 어렵다면 영양제를 통해 보충하는 것도 좋은 방법이에요.\n\n- 술·담배 금지\n\n흡연은 체내 활성화 산소를 증가시켜 정자의 기능을 감소시키고 정자 핵의 DNA를 손상시켜 난임을 유발해요.\n\n또 알코올 섭취로 남성호르몬 및 정자 형성에 부정적인 영향을 끼쳐요.\n\n임신을 계획중인 예비 아빠라면 금연과 금주, 미리미리 준비해봐요!\n\n- 고환온도 낮게 유지\n\n고환에서 정자가 만들어질 때, 또 정자가 부고환이나 정관을 통해 이동할 때 고환의 온도가 오르면 정자의 수 뿐만 아니라 운동성과 모양에도 나쁜 영향을 줘요.\n\n고환의 온도가 높아지는 것을 막으려면 사우나, 찜질방, 빈번한 반신욕 등의 상황은 가급적 피하도록 해요.\n\n몸을 조이는 속옷이나 바지는 입지 말고, 너무 오래 앉아 있거나 다리를 꼬고 앉는 자세도 좋지 않답니다.",
          },
          {
            subTitle:
              "임신은 부부가 함께 달리는 마라톤, 지금부터 같이 준비해요!",
            discribed:
              "임신기간을 잘 보내기 위해서는 엄마와 아빠의 협동이 중요해요.\n\n두 사람이 함께하는 긴 레이스가 이제 막 시작됐어요!\n\n옳은 길을 선택하고, 바른 자세로 달릴 수 있도록 멋진 페이스메이커가 되어주세요.\n\n그러기 위해서는 서로를 깊이 이해하고 앞으로의 여정에 대해 잘 알아야겠죠?\n\n마음을 터놓는 깊은 대화를 나누고, 임신에 대해 공부해가며 새로운 가족을 맞이하기 위한 40주의 대장정을 함께 달려봐요!",
          },
        ],
      },
    },
    {
      week: 3,
      baby: {
        head: {
          title: "아직은 태아가 아닌 배아!",
          discribed: "",
          size: "약 0.2mm",
        },
        body: [
          {
            subTitle: "착상을 시작해요!",
            discribed:
              "3주차의 배아는 약 0.2mm크기에 무게는 1g 미만으로 수정란은 수정이 된지 약 3일후 자궁으로 들어가요.\n\n그 후에는 빠르게 세포 분열을 시작해 태아로 성장하게 된답니다.\n\n약 7일의 시간이 지난 뒤 착상이 시작돼요.\n\n착상이란 착상이란, 난자와 정자의 수정을 통해 만들어진 배아가 자궁 내벽에 완전히 안착하여 태아에게 필요한 산소 및 영양분을 엄마로부터 받을 수 있는 상태를 의미해요.\n\n착상이 완전히 완료된 후에는 드디어 임신이 되었다고 할 수 있어요!\n\n물론 아직은 초음파 검사로 확인하기엔 조금 이른 시기예요.",
          },
        ],
      },
      mom: {
        head: {
          title: "아직은 임신을 확인하기 어려워요!",
          discribed: "아직 몸에 큰 변화가 없을수도 있어요.",
        },
        body: [
          {
            subTitle: "아직까지 임신임을 알 수 있는 뚜렷한 자각 증세는 없어요!",
            discribed:
              "자궁 안에서 양수가 만들어지고고, 자궁은 평소와 같이 달걀 정도 크기로 변화는 없어요.\n\n하지만 3주차 정도 되면 생리 예정일이 많이 지난 상태로 임신을 의심해 볼 수 있으니 뭔가 평소와는 다른 점이 느껴진다면 임신 테스트를 해보는 것이 좋아요!",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "기초체온이 올라가 미열이 나고 몸이 나른하다고 느끼기도 하며, 피로감을 자주 느끼고 잠이 많아 질 수 있어요.\n\n조금 이르게 가벼운 입덧이 있을 수 있고 후각이 예민해지기도 해요.\n\n유방의 통증이나 아랫배가 당기는 느낌이 있을 수 도 있답니다.",
          },
          {
            subTitle: "임신 테스트를 해봐요!",
            discribed:
              "임신 첫 달에는 임신 사실을 가능한 한 빨리 확인하는 것이 좋아요.\n\n그래야 감기약 복용이나 음주와 같은 임신 초기 흔히 저지르기 쉬운 실수들을 피할 수 있기 때문이에요.",
          },
          {
            subTitle: "먹는것도 신경써서!",
            discribed:
              "임신 초기는 태아의 뇌와 장기가 만들어지는 중요한 시기인 만큼 균형잡힌 식사가 중요하겠죠?\n\n단백질은 태반과 태아의 두뇌, 근육 형성에 반드시 필요한 영양소예요.\n\n임신기간 내내 충분히 섭취할 수 있도록 해야해요.\n\n또, 임신 후에는 체내 혈액량이 계속 증가하게 되는데 이때 철분의 역할은 아주 중요해요.\n\n특히 철분은 비타민C와 함께 섭취하면 흡수가 더 잘 되기 때문에 신선한 과일과 채소, 영양제를 같이 섭취하면 더 좋아요.\n\n지방 역시 임신 기간 동안 필요한 열량과 수유기 유즙 형성을 위해 반드시 필요해요.\n\n칼슘은 태아의 골격과 심장, 신경과 근육 발달에 꼭! 필요한 영양소예요.\n\n칼슘은 요거트, 치즈 등에 풍부하게 함유되어 있고 칼슘의 체내 흡수율을 높이기 위해 비타민D를 함께 섭취하는것을 추천드려요.",
          },
        ],
      },
      dad: {
        head: {
          title: "엄마의 컨디션 변화를 주의깊게 관찰해주세요!",
          discribed: "호르몬 분비로 엄마의 컨디션이 달라질 수 있어요.",
        },
        body: [
          {
            subTitle: "차근차근 준비해요!",
            discribed:
              "3주차부터는 조금씩 증상이 나타날 수 있어요.\n\n임신과 관련된 증상들을 숙지하고 있다면 엄마에게 큰 도움이 될거예요.\n\n지금부터 미리미리 공부하고 엄마의 상태를 주의깊게 관찰하도록 해요.",
          },
          {
            subTitle: "반드시 금연!",
            discribed:
              "엄마와 태아에게 담배연기는 치명적이라는 사실은 너무 잘 알고 계시겠죠?\n\n흡연은 절대 금물! 반드시 금연해야 해요.\n\n금연에 어려움을 겪고 있다면 보건소 금연 클리닉의 도움을 받아보는 것도 하나의 방법이에요.\n\n몇번을 강조해도 모자란 사실, 임신은 엄마와 아빠가 함꼐하는 긴 여정임을 명심하세요!",
          },
        ],
      },
    },
    {
      week: 4,
      baby: {
        head: {
          title: "아기집이 만들어졌어요!",
          discribed: "",
          size: "1mm 미만",
        },
        body: [
          {
            subTitle: "아직은 태아가 아닌 배아!",
            discribed:
              "임신4주차의 배아는 머리와 몸통이 나뉘고, 세포도 외배엽, 중배엽, 내배엽으로 나뉘어요.\n\n이들은 각각 다른 신체 기관으로 발달하게 된답니다.\n\n가장 위쪽에 있는 외배엽은 피부,털, 손톱, 발톱, 뇌, 척수, 신경을 만들고, 중간에 있는 중배엽은 근육, 골격, 비뇨생식기, 심장, 혈관과 혈액을 연결하는 다른 기관들을 생성해요.\n\n가장 안쪽에 있는 내배엽은 여러 장기의 내부 포장인 점막과 폐, 창자와 이를 연결하는 분비샘을 만들어요.",
          },
          {
            subTitle: "아기는 열심히 성장중!",
            discribed:
              "착상 후 5일 정도가 지난 수정란은 바깥쪽 중심부에 몸의 앞뒤나 좌우를 결정하는 하나의 관이 생기는데, 이것이 바로 신경관이에요.\n\n신경관은 시간이 흐르면서 뇌와 척추로 나누어져 발달하게 되며 나중에는 중추신경의 근원이 돼요.\n\n뿐만아니라 심장을 형성하는 조직도 벌써 서서히 만들어지고 있어요.\n\n양수를 담당하는 주머니를 양막낭 이라고 부르는데 이제 차차 양수의 양이 늘어나면서 엄마의 배가 불러와요.\n\n아직 배아의 크기는 너무 작아 초음파로 확인하기 어렵지만, 아기집과 난황은 볼 수 있어요!\n\n물론 사람마다 개인차가 있어 아기집이 제때 보이지 않는다고 해서 너무 초초하고 불안해 하지 않으셔도 돼요.",
          },
        ],
      },
      mom: {
        head: {
          title: "축하합니다, 임신입니다!",
          discribed: "생리를 하지않고 임신 테스트 결과가 양성으로 나와요.",
        },
        body: [
          {
            subTitle: "기관형성기란?",
            discribed:
              "임신 4주 차는 수정란이 나팔관을 거쳐 자궁벽에 착상되고 아기의 기관이 점점 형성되어 가는 시기예요.\n\n임신 4주부터 10주까지를 기관 형성기라고 하는데, 이 시기동안 태아의 눈코입, 뇌, 팔다리, 내장기관 등이 형성돼요.\n\n그렇기 때문에 이 시기에는 약물의 복용이나 유해환경 노출에 대한 각별한 주의가 필요해요.\n\n약물 복용 및 X선 촬영은 반드시 의사와의 상담 후 진행해주세요!",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "임신 4주 차부터 엄마는 앞서 확인했던 1~3주 차의 증상들이 보다 명확하게 나타나게 되는데요, 착상혈이 보이거나 아랫배가 콕콕 찌르는듯한 통증을 느낄 수 있어요.\n\n또, 자궁에 태아가 착상하면서 방광을 자극해 소변이 자주 마렵고 장기능 저하로 인한 변비가 일어나기도 하며 경미한 입덧 증상이 나타나기도 해요.",
          },
          {
            subTitle: "어떤 병원을 선택할까요?",
            discribed:
              "임산부와 태아의 건강 상태를 꼼꼼히 체크하고 안전하게 분만할 수 있는 병원을 선택할 때에는여러 가지 조건을 신중히 고려해야해요.\n\n중간에 병원을 바꾸는 일 없이 임신 초기부터 출산까지 같은 의사에게 꾸준히 진찰을 받기 위해서는 병원들의 장단점을 따져보고 반드시 직접 병원을 방문해 진료를 받아본 후 결정하는 것을 권해드려요.\n\n그렇다면 어떤 조건들을 고려해야 할까요?\n\n- 집과의 거리\n임신기간동안에는 매달 정기검진을 받아야 하고, 막달이 가까워 지면 1~2주에 한 번씩 병원에 가야 해요.\n\n임신부터 출산 시까지 병원에 가는 횟수는 평균적으로 15회 이상, 검진이 아니더라도 이상 중상이 보일 때는 병원에 바로 갈 수 있어야 해요.\n\n무거운 몸을 이끌고 병원에 가는 건 보통일이 아니죠.\n\n집에서 차로 20~30분 이내에 갈 수 있는 거리나 걸어서 갈 수 있는 거리가 부담이 없어요.\n\n- 산모의 건상 상태\n심장 질환이나 고혈압, 당뇨병 등 특정 질환이 있거나 고령임신, 임신중독증, 전치태반 등 고위험 임산부라면 내과나 소아과와 협진이 가능하고 응급 상황 시 수술이 가능한 병원에서 진료를 받아야 하기 때문에 종합병원이나 산부인과 전문 병원을 선택 하는 것이 좋아요.\n\n- 분만 방법\n가족 분만, 수중 분만 등 자신이 원하는 분만법이 가능한지 확인해요.\n\n- 기타\n모자동실이나 산후조리, 가족분만실과 같은 병원의 시설이나 비용, 의료진의 전공분야 등을 확인해보세요.",
          },
          {
            subTitle: "국민행복카드를 이용하세요!",
            discribed:
              "정부에서는 임산부에게 건강한 태아의 분만과 산모의 건강관리를 위해 진료비 일부를 국민행복카드를 통해 지원하고 있어요.\n\n임신 1회당 100만원 이용권의 국민행복카드가 지원되며 다태아 임산부는 140만원까지 지원되고 분만 취약자의 경우는 20만원이 추가로 지원돼요.\n\n신청방법과 지원자격, 사용 방법에 대한 자세한 내용은 www.voucher.go.k 에서 확인해보세요!",
          },
        ],
      },
      dad: {
        head: {
          title: "본격적인 아빠의 역할이 시작돼요!",
          discribed: "엄마와 아기를 생각해 마음을 단단히 먹으세요.",
        },
        body: [
          {
            subTitle: "첫 초음파와 임신 확인!",
            discribed:
              '임신테스트기로 임신을 확인한 후, 피검사에 이어 첫 초음파로 아기집을 확인하고 나서야 "임신입니다." 소리를 공식적으로 들을 수 있고, 임신 사실을 증명하는 확인 서류를 받을 수 있어요.\n\n공식적으로 임신 사실을 확인 할 수 있는 첫 산부인과 방문에 아빠도 꼭 함께해주세요.\n\n아내와 함께 축하하고, 기쁨을 충분히 만끽해봐요!\n\n이제 조금 실감이 나시나요?\n\n앞으로 아내와 남편 모두 이전까지 경험해보지 못한 다양한 감정들을 느끼게 될거예요.\n\n그런데 잠깐! 너무 축하할 만한 소식이지만 서둘러 주변에 소식을 알리기 보다는 조금 기다려주세요.\n\n임신 극 초기는 불안정한 시기이기때문이에요.\n\n조금만 시간을 가지고 기다렸다가, 안정기에 접어든 후에 주변에 알려도 늦지 않답니다!',
          },
          {
            subTitle: "반드시 금연!",
            discribed:
              "무슨일이 있어도 흡연은 금물!\n\n간접흡연이 엄마와 아기에게 얼마나 해로운지는 잘 알고 있겠죠?\n\n나가서 피우고 냄새를 빼고 들어와도 괜찮지 않.아.요.\n\n담배연기가 곳곳에 스며들어 3차 흡연으로 이어져요.\n\n아직까지 흡연을 그만두지 못했다면 이제는 정말 결단을 내려야 할 때!\n\n아기를 생각해서라도 마음을 단단히 먹자구요!",
          },
          {
            subTitle: "우리 아이는 뭐라고 부를까요?",
            discribed:
              "피검사를 마치고 초음파로 아기집까지 확인하고 나니 정말 아기가 찾아온 것이 실감나지 않으신가요?\n\n그렇다면 뱃속의 아기에게 이름을 지어주는 건 어떨까요?\n\n태아의 오감중 가장 먼저 발달하는 감각은 청각이에요.\n\n임신 7개월이 되면 태아는 자궁 밖의소리를 구분 할 수 있게되고, 태명을 부르며 안정적 태교를 하면 태아의 뇌 발달이 촉진돼요.\n\n아내와 함께 상의하여 태명을 지어보세요!",
          },
        ],
      },
    },
    {
      week: 5,
      baby: {
        head: {
          title: "저를 병원에서 확인할 수 있어요!",
          discribed: "깨알만 한 크기에요!",
          size: "약 1mm",
        },
        body: [
          {
            subTitle: "아기집이 보여요!",
            discribed:
              "초음파로 아기집을 확인할 수 있어요!\n\n이 시기 태아는 꼬리가 달린 올챙이 모습에 가까워요.\n\n꼬리 부분이 아기의 몸통, 다른 튀어나온 부분은 머리가 된답니다.\n\n태아의 심장, 위 등의 장기가 형성되기 시작해요.\n\n혈액의 순환이 가장 중요하기 때문에 심장이 가장 먼저 만들어져요.\n\n아직 초음파로는 확인이 어렵지만, 태아의 심장은 뛰고있어요!",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 극초기, 뭐든지 조심조심!",
          discribed: "임신 초기 증상들이 나타나기 시작해요.",
        },
        body: [
          {
            subTitle: "신체적 변화가 나타나기 시작해요!",
            discribed:
              "병원에서 임신 사실을 확인하셨나요?\n\n예비 엄마가 되신 것을 축하합니다!\n\n임신 5주 차부터는 많은 신체적 변화와 함께 내가 정말 임신했구나를 실감할 수 있게 될거예요.",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "입덧이 시작되고 후각이 예민해져요.\n\n감정 기복이 생기고 우울감을 느끼기도 하죠.\n\n기초체온이 높아지고 몸이 으슬으슬 몸살 기운이 있을 수 있어요. 또, 소화 기능이 떨어져 변비나 설사가 생기기도 해요.\n\n쉽게 피로감을 느끼며 잠이 많아질 수 있어요.",
          },
          {
            subTitle: "만약 임신사실을 모르고 약을 먹었다면...",
            discribed:
              "임신 초기에 나타나는 증상들을 감기로 오해해 약을 복용하는 일은 종종 있는 일이랍니다.\n\n이런 분들은 혹시 내가 먹은 약이 아기에게 나쁜 영향을 끼치진 않을지에 대한 걱정으로 마음을 졸이곤 하지요.\n\n하지만 대부분의 경우 큰 문제가 되지 않아요.\n\n물론 장기간에 걸쳐서 기형을 유발할 수 있는 약을 다량 복용할 경우엔 문제가 될 수 있어요. 그러나 전체 기형 중에서 특정 약물로 인해 야기되는 기형은 1% 미만으로 매우 드물어요.\n\n그렇기 때문에 만약 임신 사실을 모르고 약물을 복용했다 하더라도 너무 크게 걱정하지 말고, 산부인과 전문의를 통해 상담 후 큰 이상이 없다면 안심하세요!",
          },
          {
            subTitle: "조심, 또 조심!",
            discribed:
              "임신 5주~8주 차는 엄마에겐 임신의 여러 가지 신호가 나타나고, 태아에게는 많은 성장이 일어나는 시기인 만큼 각별한 주의가 필요해요!\n\n임신 초기에는 무리하거나 스트레스를 많이 받을 경우 유산의 위험이 따를 수 있기 때문에 무리한 운동이나 장시간 여행, 오랜 시간 동안 서 있는 것은 삼가도록 해요.\n\n반려동물이 있다면 화장실 청소는 아빠에게 부탁하는 것이 좋아요.\n\n톡소플라즈마증의 위험 때문인데, 가능성은 몹시 희박하지만 최대한 조심하는게 좋겠죠?",
          },
        ],
      },
      dad: {
        head: {
          title: "임신 극초기엔 아빠도 조심, 또 조심!",
          discribed: "아빠가 할 수 있는 일을 찾아볼까요?",
        },
        body: [
          {
            subTitle: "건강한 아기를 위해 가장 중요한 것은 엄마의 건강과 안정!",
            discribed:
              "임신 사실을 알게된 엄마는 기쁘면서도 앞으로의 일들에 대한 두려운 마음이 들게 될거예요.\n\n이때 정말 중요한 남편의 역할!\n\n하루에도 몇번씩 느껴지는 불편한 감정들과 몸의 변화들로 고생하고있는 있는 아내를 도와주세요.\n\n아내에게 충분한 관심과 애정, 정서적인 지지를 보여주어 아내가 안심할 수 있도록 해주세요. 또, 아빠가 할 수 있는 일이 어떤것이 있을지 생각해보고 차근차근 준비해봐요!\n\n좋은 아빠를 위한 준비는 아기가 태어난 뒤에 시작하면 너무 늦어요.\n\n엄마 아기, 그리고 아빠 자신을 위해서! 위해 꾸준히 공부하고, 연구해보도록 해요.\n\n임신과 출산에 관련된 책을 읽거나 부모가 되기위한 준비를 하는 수업에 참여해 보는 것도 좋은 방법이에요.\n\n자, 40주간의 긴 여정은 이제 시작입니다.\n\n예비아빠, 예비엄마 화이팅!",
          },
        ],
      },
    },
    {
      week: 6,
      baby: {
        head: {
          title: "콩콩, 심장이 뛰고있어요!",
          discribed: "콩알만 한 크기에요!",
          size: "약 3~9mm",
        },
        body: [
          {
            subTitle: "심장이 뛰어요!",
            discribed:
              "임신 6주차에는 태아의 뇌와 척수의 신경세포가 80% 이상 만들어지고, 질 초음파를 통해 태아의 심장이 뛰는 것을 확인할 수 있어요.\n\n이 시기의 태아는 뇌가 빠른속도로 성장하며 머리의 크기가 커지고 뼈대의 중심부가 이루어져요.\n\n태아의 간이 혈구 생산 작업을 맡고, 뇌는 근육과 장기의 운동을 통제하기 시작해요.\n\n이제 태아는 완두콩 정도의 크기로 자랐어요!\n\n산모에게 여러 가지 신체적 변화나 나타나는 만큼 태아도 빠르게 성장하고 있는 시기이기 때문에 각별한 주의가 필요하답니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "제가 대체 왜이럴까요? 정답은 호르몬 때문에!",
          discribed: "호르몬의 영향이 점점 심해져요.",
        },
        body: [
          {
            subTitle: "배는 아직...",
            discribed:
              "이 시기에는 이전보다 뚜렷해진 여러 증상들에 비해 신체적인 변화는 크지 않아요.\n\n자궁이 달걀 크기에서 레몬 크기만큼 커졌지만 아직은 배가 나온것이 느껴지지 않을거예요.",
          },
          {
            subTitle: "입덧이 시작 될 수 있어요!",
            discribed:
              "보통 입덧은 빠르면 임신 4주 차 말, 5주 차쯤 시작해 14주 이후로는 점점 사라지게 돼요.\n\n하지만 입덧은 그 정도와 종류에 있어 개인차가 심해 약간 메슥거리는 정도나 음식 냄새나 물만 마셔도 토하는 수준까지 다양하게 나타나며 아예 음식을 거부하거나 반대로 먹덧으로 오는 경우도 있어요.\n\n입덧이 심할 경우는 병원을 방문하여 도움을 받도록 하고 보편적으로 입덧은 아침이나 공복에 느끼는 경우가 많기 때문에 조금씩 자주 먹는 습관을 들이도록 해요.",
          },
          {
            subTitle: "화장실을 자주가요!",
            discribed:
              "호르몬의 영향으로 화장실을 자주 가게 돼요.\n\n사람융모성성선자극호르몬(hCG)이 골반쪽으로 향하는 혈류량을 늘리고, 신장은 노폐물을 배출하기 위해 더 많이 일을하며 커진 자궁이 방광을 압박하기 때문이에요.\n\n빈뇨는 상당한 스트레스를 유발하는 증상이지만, 화장실 가는 횟수를 줄이기 위해 물을 적게 마시는 행위는 금물!\n\n혈류량이 증가하게 되는 지금 엄마에게는 충분한 수분 섭취가 필요해요.",
          },
          {
            subTitle: "기분은 마치 롤러코스터...",
            discribed:
              "호르몬의 변화로 나타날 수 있는 또다른 증상으로는 감정기복이 있어요.\n\n이 시기의 엄마들은 감정적으로 예민해지고 쉽게 짜증이 나거나 우울감을 느낄 수 있어요.\n\n하지만 이 모든건 자연스러운 현상이니 너무 걱정하지 않아도 돼요.",
          },
          {
            subTitle: "미리미리 준비해요!",
            discribed:
              "지역 보건소 혜택과 지원 범위를 확인하고 신청해봐요.\n\n또, 태아를 위한 보험이 있다는 사실.\n\n알고 계셨나요?\n\n만약 검진 과정에서 이상이 있다면 보험 가입이 어려워지니 미루지 말고 여러 상품들을 비교해 미리미리 가입하는걸 추천해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠의 역할이 중요해요!",
          discribed: "갑자스러운 변화들로 힘들어하는 엄마를 도와주세요.",
        },
        body: [
          {
            subTitle: "감동의 순간들을 기록으로!",
            discribed:
              "아기의 심장소리를 들어보셨나요?\n\n그 순간의 감동과 경이로움, 말로는 쉽게 설명할 수 가 없죠. 이러한 순간들을 태교일기로 기록해보는건 어떨까요?\n\n임신기간동안의 작은 변화들을 적고, 사진을 찍어 기록을 남겨보세요. 부담을 가질 필요는 없어요.\n\n기록을 남긴다는 사실 자체가 중요하니까요.\n\n이렇게 남겨진 일기들은 아내에게도 힘이 될 뿐 아니라 미래의 아기에게도 큰 선물이 될 수 있을거예요.",
          },
          {
            subTitle: "아빠가 할 수 있는 일!",
            discribed:
              "임신은 엄마와 아빠가 함께 준비해야하는 일!\n\n무슨 일이든 함꼐 걱정하고 함께 헤쳐나가도록 해요.\n\n하나의 생명을 맞이할 준비를 한다는 건, 모든것이 걱정되고 조심스러운 일이에요.\n\n걱정을 하지 않을 수 있다면 좋겠지만, 무조건 걱정하지말라는 말은 위로가 아닌 무책임으로 다가올 수 있죠.\n\n그냥 같이 걱정해주세요. 그리고 같이 헤쳐나가도록 해요. 함께하고 있다는 확신을 주세요!\n\n아빠는 아빠의 자리에서, 아빠가 할 수 있는 일을 해요.\n\n엄마의 병원 일정을 엄마보다도 더 꼼꼼히 확인하고, 날짜가 다가올수록 미리 확인하며 챙겨요.\n\n병원에 갈때 동행하는 것도 중요해요.\n\n처음부터 능숙한 사람은 없어요. 훌륭한 아빠가 되기위해 노력, 또 노력. 반드시 명심하세요!",
          },
        ],
      },
    },
    {
      week: 7,
      baby: {
        head: {
          title: "이제는 제법 사람의 모습이에요!",
          discribed: "크랜베리 한 알만 한 크기에요!",
          size: "약 1.0~1.5cm",
        },
        body: [
          {
            subTitle: "이제 제법 머리와 몸통이 구별돼요!",
            discribed:
              "형태만 갖추었던 얼굴도 좀 더 정교해졌어요.\n\n이마는 불룩 솟아 있고 코는 납작하지만, 점처럼 생긴 눈과 콧구멍이 보여요.\n\n눈에 수정체가 생겨 빛을 느낄 수 있고, 머리와 뇌도 점점 커지고 있어요.\n\n머리가 척추 위에 곧게 서고 꼬리는 점점 사라져요.\n\n특히 팔다리가 쑥쑥 자라나 다리를 구분할 수 있고, 손과 어깻죽지도 알아볼 수 있어요.\n\n물론 아직은 그냥 볼록하게 튀어나온 혹처럼 보이긴 하지만, 한달쯤 지나면 자유롭게 움직일수 있게 될 거예요!\n\n이제 심장이 완전히 형성되고, 내부 기관들도 빠르게 만들어져요.\n\n태아의 배에는 간 기관을 만들어내기 위한 간 돌기가 나타나고, 폐에는 기관지가 생겨요.\n\n위와 창자가 모양을 갖추기 시작하고 맹장과 췌장도 생긴답니다!",
          },
        ],
      },
      mom: {
        head: {
          title: "기분도 몸 상태도 오락가락!",
          discribed:
            "호르몬의 영향으로 찾아오는 다양한 변화들, 무리하지 말고 조심조심!",
        },
        body: [
          {
            subTitle: "조금씩 증상들이 나타나요!",
            discribed:
              "아직 겉으로 보기에 배가 많이 불러온 상태가 아니라서 티가 많이 나지는 않아요.\n\n그렇지만 지금까지 느꼈던 증상들이 더 심해지거나 체중이 조금씩 증가하는 등 산모에게는 불편함이 생기는 단계라고 볼 수 있죠.",
          },
          {
            subTitle: "입덧의 증상이 점점 심해져요!",
            discribed:
              "보통 임신 7주 차 정도에는 입덧이 심해져 음식을 잘 먹지 못하거나 냄새만 맡아도 구역질을 하는 경우가 많아요.\n\n입덧은 임신 중 자연스러운 과정으로 자신만의 입덧 완화를 음식을 찾아 입덧 기간 동안 섭취하는 것도 좋은 방법이에요.",
          },
          {
            subTitle: "배변활동에 변화가 생겨요!",
            discribed:
              "호르몬의 변화로 소화기계 기능이 약해지고, 입덧으로 규칙적인 식사에 어려움이 생기면서 변비가 생길 수 있어요.\n\n식이섬유가 풍부한 곡물류, 해조류, 뿌리채소와 과일 등의 섭취를 통해 증상을 완화 할 수 있어요.\n\n아, 변비약을 사용하려면 꼭 담당 의사 선생님과 상담 후 사용해야해요!",
          },
          {
            subTitle: "호르몬의 변화는 피부 트러블을 유발할 수 있어요!",
            discribed:
              "자연스러운 현상이니 너무 스트레스 받지 않아도 된답니다.",
          },
          {
            subTitle: "가슴에 변화가 생겨요!",
            discribed:
              "가슴에 지방층이 쌓이고 가슴으로 흐르는 혈액이 늘어나면서 가슴의 크기가 커지게 돼요.\n\n뿐만 아니라 유두의 색이 짙어지고 가슴을 살짝 스치기만 해도 통증이 느껴지기도 하는데.\n\n이러한 증상들은 모유수유를 준비하기 위한 과정이랍니다.\n\n통증 완화를 위해 마사지나 온찜질을 해보세요.",
          },
          {
            subTitle: "몸무게는 얼마나?",
            discribed:
              "임신기간 중에 체중이 증가하는건 자연스러운 현상이에요.\n\n하지만 과도한 체중의 증가는 아기에게도, 엄마에게도 좋지 않답니다.\n\n그렇다면 어느정도의 체중 증가가 적정 수치일까요?\n\n권장 체중 증가량은 임산부의 체질량지수에따라 다르지만, 임신 초기 3개월까지는 0.5~2kg 증가를 권장하고 있어요.\n\n또한, 비만한 임산부일수록 임신 중 권고되는 체중 증가량이 적기 때문에 임신 초기부터 적극적으로 체중을 조절하는것이 중요해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "입덧이 심한 아내를 위해!",
          discribed: "아빠의 도움이 절실해요.",
        },
        body: [
          {
            subTitle: "집안일을 도와주세요!",
            discribed:
              "임신한 아내에게 과도한 집안일은 무리가 돼요.\n\n임신 초기인 지금은 유산의 위험이 높은 편이기 때문에, 아빠가 보다 적극적으로 집안일에 참여해주세요.\n\n특히, 입덧으로 고생하고 있는 아내를 위해 후각을 자극하는 음식물 쓰레기 처리 및 냉장고 청소 등은 아빠가 전적으로 담당해주면 좋겠죠?.\n\n식사준비를 도맡아 하는 것도 좋은 방법이에요.\n\n식사를 준비하며 이런 저런 요리를 통해 아내가 비교적 잘 먹을 수 있는 음식을 찾아보도록 해요.",
          },
        ],
      },
    },
    {
      week: 8,
      baby: {
        head: {
          title: "지난 일주일사이 두배가 넘게 자랐어요!",
          discribed: "곰젤리만 한 크기에요!",
          size: "약1.6~2.2cm",
        },
        body: [
          {
            subTitle: "이제 점점 사람의 형태가 되어가요!",
            discribed:
              "이제부터는 배아가 아닌 완전한 태아라고 부를 수 있어요.\n\n태아의 몸이 길어지고, 팔다리가 세분화돼요.\n\n태아의 척추가 곧아져서 몸을 세우고 머리를 들 수 있어요.\n\n또, 팔다리가 확실히 구별되고 길이도 더 길어지며 아직은 물갈퀴같은 모양이지만 손가락과 발가락이 만들어지기 시작해요.\n\n태아의 피부는 매우 얇고 투명해서 혈관이 선명하게 보인답니다.\n\n태아의 목 가장자리에서는 귀의 바깥쪽이 만들어지고고, 얼굴에는 눈꺼풀이 생기며, 코와 윗입술이 보이기 시작해요.\n\n태반과 탯줄이 발달해 엄마로부터 영양소를 공급받으며, 꼬리는 거의 사라져가요.",
          },
        ],
      },
      mom: {
        head: {
          title: "아기가 자라나면서 자궁의 크기도 커지고 있어요!",
          discribed: "겉으로는 큰 변화가 없어도 여전히 매사에 조심해야해요.",
        },
        body: [
          {
            subTitle: "자궁이 커지고 몸무게도 서서히 늘어나요",
            discribed:
              "임신 전에는 달걀만 했던 자궁이 이제는 주먹 크기만큼 커졌어요.\n\n또 아직 겉으로는 크게 티가 나지 않지만, 조금씩 체중이 늘어나 허리선이 없어지고 옷을 입으면 조이는 느낌이 들기도 해요.\n\n다른 사람들이 눈치 챌 만큼은 아니지만, 아랫배가 단단하고 조금 부풀며 가슴의 크기도 커진 것을 느낄 수 있어요.",
          },
          {
            subTitle: "계속되는 입덧...",
            discribed:
              "입덧은 더욱 심해져 최고조를 찍게 되는데, 특히 아침에 가장 심하게 나타나요.\n\n이상한 냄새만 맡아도 구역질이 나고, 하루종일 속이 울렁거려 음식을 먹는 즉시 토해버리기도 해요.\n\n이 시기 즈음에는 어느정도 음식 파악할 수 있기 때문에, 가급적 이를 피해 식욕을 잃지 않도록 하고 먹고 싶은 음식을 조금씩 자주 먹어 영양섭취에 주의하도록 해요.\n\n만약 입덧이 너무 심각하다면 입덧을 위한 약도 있으니 병원을 방문하는게 좋아요.\n\n증상이 너무 심해지면 태아에게도 위험할 수 있으니 무조건 참는것만이 능사는 아니라는것, 명심하세요!",
          },
          {
            subTitle: "외음부 색깔이 짙어지며, 질 분비물이 많아져요.",
            discribed:
              "임신을 하면 질과 음부에 공급되는 혈액의 양이 급격히 늘어나 색깔이 짙어지고, 질에서 점액성 분비물이 늘어나요.\n\n이 분비물은 좋은 박테리아를 유지하고 세균의 감염을 막아 질을 보호해주는 좋은 분비물이랍니다.\n\n그러니 평소 속옷을 자주 갈아입고, 샤워로 몸을 청결하게 하되, 질 안쪽까지 씻지 않도록 주의해야 해요.\n\n다만, 분비물의 색깔이 짙어지고 냄새가 심하게 나거나 간지럽다면 감염에 의한 질염일 가능성이 있으므로 즉시 진료를 받도록 해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠의 노력은 엄마에게 큰 힘이 되어요!",
          discribed: "두 사람이 함께 노력하는것이 중요해요.",
        },
        body: [
          {
            subTitle: "이제 우리는 임신가정!",
            discribed:
              "이제 우리는 임신가정이라는 사실을 명심합시다.\n\n그동안 아내와 나는 각자의 영역을 지키며 맡은 일을 열심히 수행해 왔지만, 이제 아내는 임산부라는 사실을 알아야 해요.\n\n아내의 영역으로만 여겨지던 부분들이 이제는 더이상 아내만의 영역이 될 수 없어요.\n\n태아의 안정을 위해서 아내는 이전처럼 모든 일을 할 수 없고, 남편은 아내가 해오던 일들을 배우고 익혀야 해요.\n\n물론 처음부터 완벽할 순 없겠죠.\n\n그러나 작은 노력들이 모여 더 큰 결과를 만들고, 이러한 노력들은 반드시 아내에게 큰 힘과 위로가 될거예요.",
          },
        ],
      },
    },
    {
      week: 9,
      baby: {
        head: {
          title: "이제는 배아가 아닌 태아!",
          discribed: "올리브 한 알만 한 크기에요!",
          size: "약 2.3~3.0cm",
        },
        body: [
          {
            subTitle: "팔다리가 길어지고, 손가락 발가락도 생겨요!",
            discribed:
              "임신9주가 되면 태아는 꼬리가 없어지고 등이 똑바로 서게 돼요.\n\n팔은 점점 길어지고, 팔꿈치가 완성되어 구부릴 수 있게 되며, 손가락과 지문이 만들어지고 있어요.\n\n다리는 허벅지와 종아리, 발로 구분할 수 있고 발가락도 생겨요.\n\n근육이 점점 발달함에 따라 초음파 검사를 하면 태아의 움직임을 느낄 수 있어요!\n\n얼굴에는 기초적인 안면 골격이 나타나고 안면 근육도 발달해요.\n\n또, 생식기가 발달하고 있어 여아의 경우에는 난소, 남아의 경우 정소가 자라나기 시작해요.",
          },
        ],
      },
      mom: {
        head: {
          title: "쉽게 짜증이나고 피로해져요!",
          discribed: "지금 엄마의 몸속에서 아기가 쑥쑥 자라고 있어요.",
        },
        body: [
          {
            subTitle: "감정기복이 심해져요.",
            discribed:
              "무너진 호르몬의 균형때문에 짜증이 쉽게 나고 감정 기복이 심해져요.\n\n엎친데 덮친격으로 심해진 입덧이 몸과 마음을 괴롭게 하기도 해요.\n\n몸에서 느껴지는 변화들 때문에 두렵고 불안한 마음이 생기기도 하죠.\n\n하지만 이런 과정은 지극히 자연스러운 일이랍니다.\n\n마음이 싱숭생숭하고 감정의 기복이 심해질 때에는 터놓고 이야기 할 수 있는 상대에게 힘든 마음을 털어놓아 보세요.\n\n임신의 고됨에 공감해 줄 수 있는 선배 엄마든지, 남편이나 가족 또는 친한 친구도 좋아요.\n\n믿을 수 있는 사람들의 따뜻한 위로와 격려가 큰 힘이 되어줄 거예요",
          },
          {
            subTitle: "가슴에 변화가 생겨요!",
            discribed:
              "가슴이 단단하게 부풀어 오르면서 살짝만 스쳐도 아프고 유두와 유륜이 짙은 갈색을 띠게 돼요.\n\n유두를 누르면 기름 성분의 분비물이 나오기도 해요.\n\n이러한 증상들은 태어날 아기에게 모유를 먹일 수 있도록 준비하는 과정이에요.\n\n그러니 걱정하지 않아도 된답니다.",
          },
          {
            subTitle: "피로가 늘었어요!",
            discribed:
              "아침에 눈을 뜨기 힘들고, 강한 피로를 느끼며 시도때도없이 잠이 쏟아지기도 해요.\n\n지금 엄마의 몸은 태반을 만드느라 온갖 에너지를 쓰고 있어요.\n\n자연스러운 현상이니 불안해 하지말고, 엄마의 몸을 잘 챙겨주세요.\n\n모든 일을 스스로 해내려 하지 말고 남편의 도움을 받아보는 것도 좋아요.",
          },
        ],
      },
      dad: {
        head: {
          title: "취미생활은 잠시 안녕, 아내를 최우선으로!",
          discribed: "아내에겐 세심한 관심과 배려가 필요해요.",
        },
        body: [
          {
            subTitle: "아내를 이해하고, 다독여주세요!",
            discribed:
              "갑작스런 신체의 변화, 롤러코스터를 타듯 오르내리는 감정기복.\n\n임신초기 불균형한 호르몬의 영향으로 아내는 지금 충분히 혼란스럽고 불안해요.\n\n이러한 증상들은 아내가 통제할 수 있는 부분이라는것, 남편도 잘 알고 계시겠죠?\n\n임신은 힘든 것이에요.\n\n힘든 이 과정을 아내 혼자가 아닌 남편도 함께해야한다는 사실을 기억하세요.\n\n아내의 말에 귀기울이고, 아내의 변화를 주의깊게 관찰해주세요.\n\n지금의 이 시간들을 통해 부부의 유대감은 더욱 깊어질거예요.",
          },
        ],
      },
    },
    {
      week: 10,
      baby: {
        head: {
          title: "손가락 발가락이 보여요!",
          discribed: "엄마의 엄지손가락만 한 크기에요!",
          size: "약 3.1~4.0cm",
        },
        body: [
          {
            subTitle: "본격적인 태아기에 접어들었어요!",
            discribed:
              "수정 8주 후부터 태아는 빠르게 성장해요.\n\n아직은 무게는 10g도 되지 않지만 태아의 세포는 거의 자리를 잡았어요.\n\n꼬리는 완전히 사라지고 발가락 사이의 갈퀴도 점차 없어지면서 사람과 같은 형태의 형태를 보이기 시작해요.\n\n몸 안의 장기는 아직 완전하지 않지만, 신체의 거의 모든 부분이 제 모습을 띠기 시작해요.\n\n몸이 곧게 펴지고 길어지며, 얼굴의 턱과 뺨, 입술, 눈꺼풀등이 발달해요.\n\n유치와 머리카락의 바탕도 만들어지고 있답니다!",
          },
        ],
      },
      mom: {
        head: {
          title: "엄마를 괴롭히는 입덧!",
          discribed: "입덧 증상이 최고조에 달해요.",
        },
        body: [
          {
            subTitle: "입덧, 조금만 힘내요!",
            discribed:
              "몇주 전부터 시작된 입덧이 정점을 찍는 시기예요.\n\n끝나지 않을것만 같았던 괴로운 시간도 이제 조금씩 끝이 보여요.\n\n입덧 증세가 최고조에 이른 지금, 개인차는 있겠지만 약 1~2주 안에 자연스럽게 입덧이 사라져요.\n\n조금만 더 힘을내봅시다!\n\n힘들어도 조금씩 자주 먹으려고 노력해봐요.",
          },
          {
            subTitle: "아랫배에 통증이 있어요!",
            discribed:
              "임신 초기에 종종 아랫배가 콕콕 찌르듯 아프거나 뻐근한 느낌의 통증이 나타나기도 해요.\n\n이것은 태아가 자라날 자궁이 커지면서 주위 근육과 인대가 압박을 받기 떄문이에요.\n\n이 역시 자연스러운 증상이므로 너무 걱정하지 않아도 된답니다.",
          },
          {
            subTitle: "핏줄이 늘어나요!",
            discribed:
              "태아를 성장시키기 위해서는 많은 혈액량이 필요하기 때문에 엄마의 몸에 파란 핏줄이 도드라져 보일 수 있어요.\n\n특히 가슴과 배 부분에서 더 많이 관찰된답니다.\n\n하지만 이렇게 늘어난 핏줄은 출산 후 모유수유가 끝나면 자연스레 사라지니 너무 걱정할 필요 없어요.",
          },
          {
            subTitle: "칼슘과 수분섭취를 신경써주세요!",
            discribed:
              "태아의 튼튼한 성장을 위해 칼슘이 풍부한 음식을 섭취해주세요.\n\n칼슘은 태아의 뼈와 유치의 형성에 필수적이랍니다.\n\n또, 입덧의 증상이 심하다면 구토로 인해 부족해진 수분을 충분히 보충할 수 있도록 유의해주세요.",
          },
          {
            subTitle: "국민행복카드 발급을 잊지마세요!",
            discribed:
              "이제 앞으로 많은 산전검사들이 진행될거예요.\n\n혹시 아직 국민행복카드를 발급받지 않았다면 잊지말고 신청하세요!",
          },
        ],
      },
      dad: {
        head: {
          title: "입덧으로 고생하는 아내, 남편까지?",
          discribed: "함께 고통받는 쿠바드 증후군!",
        },
        body: [
          {
            subTitle: "쿠바드증후군이란?",
            discribed:
              "쿠바드 증후군의 쿠바드는 프랑스어로 '알을 품다, 부화하다'라는 뜻이예요.\n\n아내의 임신으로 남편이 아내에게서 나타나는 입덧, 식욕 상실, 메스꺼움, 구토, 불면증 등의 육체적, 심리적 증상을 함께 경험하는 것을 가리킨답니다.\n\n심한 경우 출산의 진통이나 산후우울증과 같은 증상을 겪는 경우도 있다고 해요.\n\n이러한 증상은 임신 초기에 심했다 가 점차 약해지고 임신 후기에 다시 심해지는데, 통계로 보면 임산부 남편의 3분의 1정도가 쿠바드 증후군을 경험했다고 해요.\n\n쿠바드증후군에 대한 원인은 정확히 밝혀지지 않았지만, 놀라운 것은 실제로 쿠바드 증후군을 겼는 남성들은 프로락틴의 수치가 높아지고 테스토스테론 수치는 급격히 떨어지는 등 실제 호르몬의 변화를 겪는다는 점이에요\n\n이렇게 함께 증상을 경험하는 경우는 아내의 임신에 공감을 많이 하거나 평소 아내와 유대관계가 몹시 좋을 경우, 아빠가 된다는 압박감과 불안감으로 인해 더 높은 확률로 나타나는 경향이 있어요.\n\n그러므로 새로운 환경에 대해 혼자 걱정 하고 스트레스를 받는 것보다 아내와 함꼐 태어날 아기와의 미래를 그리며 대화로 불안을 해소하는 것이 좋답니다.",
          },
        ],
      },
    },

    {
      week: 11,
      baby: {
        head: {
          title: "4배가까이 성장했어요!",
          discribed: "계란만 한 크기에요!",
          size: "약 4.1cm~5.2cm",
        },
        body: [
          {
            subTitle: "머리, 몸통, 다리가 구분돼요!",
            discribed:
              "머리와 몸통으로 구분됐던 이등신에서 삼등신이 되었어요!\n\n사지가 확실히 구별되고 길이도 길어져 손목, 손가락, 허벅지, 종아리, 발로 분화되었어요.\n\n체모가 자라나 솜털이 생기고 모든 체내 기관이 발달하여 심장, 간, 비장, 맹장, 내장이 발달해요.\n\n치아와 머리카락도 나올 준비를 하고 있고, 손톱발톱이 자랄 자리도 형성되고 있어요.\n\n곧 외부 생식기도 나타난답니다.\n\n횡격막이 생겨나면서 숨을 쉴 수 있게 되어 양수를 마시고 소변으로 배출하는 숨쉬기와 소화 연습을 해요.",
          },
        ],
      },
      mom: {
        head: {
          title: "엄마의 혈액량이 늘었어요!",
          discribed: "자궁이 커지면서 점점 필요한 혈액량이 늘어요.",
        },
        body: [
          {
            subTitle: "어지러움, 빈혈 조심!",
            discribed:
              "태아에게로 가는 혈액이 많아지면서 빈혈이나 어지러움을 느낄 수 있어요.\n\n임신을 하면 자궁과 태반의 혈관이 늘어나면서 임신 전보다 혈액량이 증가하는데 혈액 속 적혈구의 양은 그만큼 늘지 않아 상대적으로 혈액의 농도가 묽어지기 때문이에요.\n\n임산부 빈혈의 일반적인 증상은 극심한 피로감이며, 이외에도 어지럼증, 현기증, 수족냉증, 가슴 두근거림 등의 증상이 나타날 수 있어요.\n\n철분이 부족하면 적혈구의 산소를 운반하는 성분인 헤모글로빈 생산량이 감소하기 때문에 임산부는 매일 약 27mg의 철분을 섭취해주어야 해요.\n\n철분이 풍부한 음식으로는 가금류, 생선, 기름기 없는 붉은 고기, 콩, 견과류와 씨앗, 짙은 잎 채소 등이 있으며 철분 보충제를 섭취하는 것도 좋은 방법이에요.",
          },
          {
            subTitle: "질 분비물이 늘었어요!",
            discribed:
              "임신 초기에는 에스트로겐의 분비가 늘어나면서 자궁의 움직임과 골반 내 혈액순환이 활발해지고, 질 분비물 역시 증가해요.\n\n평소보다 약간 더 찐득하고 다소 시큼한 냄새가 나는 분비물이 분비될 수 있어요.\n\n임신 중 분비물은 산도와 태아가 세균으로부터 감염되는 것을 방지하고, 출산 시에는 윤활제 같은 역할을 해 태아가 산도를 원활하게 빠져나올 수 있도록 도와주는 역할을 해요.\n\n임신 중 갑작스레 늘어난 분비물 때문에 몸에 이상이 생긴 것은 아닐지 걱정하는 분들도 있지만, 이건 자궁 환경이 변화함에 따라 나타나는 자연스러운 현상이므로 걱정할 필요가 없어요.\n\n꽉 끼는 옷이나 속옷 대신 통풍이 잘되는 면 소재의 넉넉한 옷을 입어주는것이 좋아요!",
          },
        ],
      },
      dad: {
        head: {
          title: "입덧으로 고생하는 아내를 위한 남편의 노력!",
          discribed: "입덧 극복, 얼마 남지 않았어요. 조금만 더 화이팅!",
        },
        body: [
          {
            subTitle: "입덧 극복을 위하여!",
            discribed:
              "아내는 여전히 자신과의 싸움 중이에요.\n\n입덧을 하는 아내에게는 아무일이 없어도 아무일이 없는게 아니게 돼요.\n\n개인차가 있지만 보통 입덧은 대개 12주차부터 서서히 사그러들어요.\n\n먹고싶은 음식도 먹지 못하고 고생하는 아내를 위해 조금만 더 힘내봅시다!\n\n입덧으로 고생하는 엄마들은 종종 뜬금없는 음식을 먹고싶어하는 경우가 있어요.\n\n이럴 때 아내의 말을 흘려듣지 말고 꼭 음식을 준비해주세요.\n\n정말 구하기 어려운 음식이라면, 최대한 구하려고 노력하는 모습을 보여주세요!\n\n어떻게든 엄마가 원하는 음식을 구하려는 아빠의 모습은 엄마에게 큰 감동이 된답니다.\n\n입덧 완화에 있어서 시원하고 맑은 공기, 또는 바람을 쐬는 것이 도움이 된다고 해요.\n\n임산부에게 가벼운 산책은 좋다고 하니, 아내와 함께 가벼운 밤 산책을 나가보세요.\n\n입덧은 정말 흔한 임신의 증상이지만, 이로인해 저하된 삶의 질은 상상 이상이에요.\n\n이렇게 떨어진 삶의 질을 높여 줄 사람은 남편뿐이라는 사실!\n\n언제까지 지속될지 모르는 입덧이라는 덫에 걸려 고생하는 아내를 위해, 노력합시다!",
          },
        ],
      },
    },
    {
      week: 12,
      baby: {
        head: {
          title: "팔다리가 쑥쑥, 이제 머리와 몸의 비율이 그럴듯해 보여요!",
          discribed: "키위만 한 크기에요!",
          size: "약5.4~6.6cm",
        },
        body: [
          {
            subTitle: "태아의 급성장!",
            discribed:
              "임신10주부터 12주까지 태아는 급속도로 성장해 몸이 두 배 정도 커지고, 얼굴 모양도 제대로 잡히게 돼요.\n\n몇 주 전에 만들어진 신체 기관들은 점차 완성된 형태로 진행되고, 근육들이 충분히 발달해서 양수 속에서 자유롭게 움직일 수 있어요\n\n손가락과 발가락 사이가 벌어지고 손톱이 자라며, 태아의 몸 곳곳에는 모근이 생기기 시작해요.\n\n하품도 하고 손가락을 빨거나 양수를 삼킬 수 있는 반사신경이 발달하며, 내부 생식기가 확실히 나타나 남녀 성별 구분이 가능해져요.",
          },
        ],
      },
      mom: {
        head: {
          title: "자궁이 점점 커지고 있어요!",
          discribed: "자궁이 자몽만큼 커져서 골반 밖으로 나와요.",
        },
        body: [
          {
            subTitle: "자궁이 커졌어요!",
            discribed:
              "이제 엄마의 자궁은 자몽만한 크기로 커졌어요!\n\n12주 차가 되면 태아가 급격하게 성장함에 따라 자궁의 크기도 커져 아랫배가 볼록 하게 나오기도 해요.\n\n늘어난 자궁이 방광을 눌러 소변을 자주 보게 되고, 자궁을 지지하는 인대가 늘어나 아랫배나 사타구니에 콕콕 찌르는 듯한 통증이 있을 수 있어요.\n\n이러한 통증은 자연스러운 과정이지만, 일상생활에 지장을 줄 정도로 통증이 오래 지속된다면 병원을 방문해보세요.",
          },
          {
            subTitle: "얼굴과 목에 나타나는 갈색반이 나타나요!",
            discribed:
              "임신 중 호르몬의 변화로 멜라닌 색소가 늘어나면서 기미나 얼굴과 목에 불규칙한작은 점들이 나타나기도 해요.\n\n이를 임신 가면 또는 갈색반이라고 하는데, 이런 현상은 출산을 하고 나면 1년 이내에 엷어지거나 대부분 없어진답니다.",
          },
          {
            subTitle: "1차기형아검사를 진행해요!",
            discribed:
              "임신 10~13주 사이 1차 기형아 검사를 진행해요.\n\n태아 목투명대 검사는 기본적인 기형아 검사로, 다운증후군과 같은 염색체 기형 여부를 확인할 수 있어요.\n\n엄마가 특별히 준비할 내용은 없으므로, 편안한 마음으로 검사를 받으면 된답니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "안정기에 접어들고 있어요!",
          discribed: "불안해하는 아내를 잘 지지해주세요!",
        },
        body: [
          {
            subTitle: "큰 산을 하나 넘었군요!",
            discribed:
              "이제 드디어 12주차에 접어들었어요.\n\n이제는 슬슬 안정기에 접어들고 있다고 볼 수 있어요.\n\n아내에게 수고했다는 말을 전해주세요.\n\n남편도 정말 수고 많았습니다.\n\n보통 12주차에는 1차 기형아 검사를 받게되데요, 아내는 지금 걱정이 이만저만이 아닐거예요.\n\n남편도 불안한 마음인건 마찬가지 이겠지만, 서로 의지하고 다독이며 이겨냅시다!\n\n두 사람은 이제 큰 산 하나를 겨우 넘은거나 마찬가지예요.\n\n혼자가면 어려운 길이지만, 둘이라면 거뜬히 완주할 수 있다는 마음가짐으로 남은 여정도 화이팅입니다!",
          },
        ],
      },
    },
    {
      week: 13,
      baby: {
        head: {
          title: "이제는 3등신이에요!",
          discribed: "작은 사과만 한 크기에요!",
          size: "약 6.7~7.5cm",
        },
        body: [
          {
            subTitle: "신체기관들이 제자리로!",
            discribed:
              "태아의 신체 조직과 기관들이 더욱더 빠르게 성숙되어 가요.\n\n커다랗게 부푼 탯줄 형태로 있던 장기들은, 태아의 복부 움푹한 곳으로 이동하기 시작해요.\n\n얼굴도 거의 완전한 형태를 갖추었답니다.\n\n이마 가장자리에서 시작한 눈이 콧등 주변으로 모아져 제법 자리를 잡고, 귀도 머리 양 옆에 위치해요.\n\n눈꺼풀은 아직 눈을 덮고있지만, 눈은 완전한 형태를 갖추고 있어요.\n\n숨태아는 지금 열심히 숨쉬기연습을 하고있어요.\n\n양수를 마시고 뱉으며 폐를 발달시키는 중이랍니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "입맛이 돌아오고 있어요!",
          discribed:
            "이제부터는 본격적으로 영양을 따지며 건강한 식생활을 해야할 때!",
        },
        body: [
          {
            subTitle: "입덧이 많이 사그라들어요!",
            discribed:
              "13주차에 접어들면서 한참을 고생했던 입덧이 차차 사그라들어요.\n\n덕분에 잃었던 식욕이 돌아오고, 그동안 먹지 못했던 음식들을 마구 먹고싶어지기도 해요.\n\n하지만 영양 균형이 꺠진 불규칙하고 무분별한 식사는 체중 조절을 방해하고, 임신 중독증이나 임신성 당뇨의 위험이 높아져요.\n\n영양소를 골고루 갖춘 균형잡힌 식단을 유지하며 체중은 1주일에 500g, 한달에 2kg이상 늘지 않도록 항상 주의해주세요!",
          },
          {
            subTitle: "눈이 건조해져요!",
            discribed:
              "호르몬의 변화로 눈에서 자연스럽게 분비되는 눈물의 양이 줄어, 눈이 건조해지는 느낌을 받을 수 있어요.\n\n이는 자연스러운 현상이지만, 정도가 심해 일상생활에 어려움을 겪는다면 안과 전문의의 진료를 받아야 해요.",
          },
          {
            subTitle: "배와 허벅지, 엉덩이에 임신선이 나타나요!",
            discribed:
              "임신을 하면 복부, 허벅지, 엉덩이 등에 임신선이 생길 수 있어요.\n\n임신선은 개인차가 있어 사람에 따라 심하게 생길 수도 있고 전혀 생기지 않을 수도 있어요.\n\n보통 갑자기 몸무게가 늘어나는 경우 임신선이 생기고 출산 후 옅어지지만 완전히 사라지지는 않아요.\n\n임신선을 없애기 위해 함부로 연고나 화장품을 바르면 안돼요!\n\n스테로이드 성분이 함유된 경우 피부를 통해 태아에게 전달될 수 있어요.\n\n또한 임신선 부위를 심하게 마사지하면 자궁 수축을 유도할 수 있기 때문에 강한 마사지는 삼가주세요.",
          },
          {
            subTitle: "이제는 기쁜 소식을 전해도 될 때!",
            discribed:
              "임신 초기에는 쉽게 유산할 확률이 높기 때문에 주위에 임신 사실을 알리는 일을 잠시 참아달라고 했던 것, 기억하시죠?\n\n지금이 바로 주위에 이 기쁜 소식을 전할 때예요!\n\n이제는 안정기에 접어들었기 떄문이에요.\n\n일을 하고있는 워킹맘이라면 이제 직장에 임신 사실을 알리고 출산과 육아 휴직에 대해 논의해보세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "엄마와 뱃속의 아기까지 케어하는 아빠는 슈퍼맨!",
          discribed: "엄마와 아기의 건강을 위해 식단 조절을 도와주세요!",
        },
        body: [
          {
            subTitle: "이미 육아는 진행중!",
            discribed:
              "시간이 흘러 어느덧 벌써 넉달이라는 시간이 지나갔어요.\n\n이제 뱃속의 아기는 완전한 태아가 되어 무럭무럭 자라나고, 몸의 모든 구조가 완성되는 단계에 이르렀어요.\n\n두 사람이 함께 아기의 건강한 성장을 위해 고군분투하는 지금 이순간부터, 육아는 이미 시작되었다고 볼 수 있지요.",
          },
          {
            subTitle: "입덧이 사그라든 아내를 위해!",
            discribed:
              "부단히도 아내를 괴롭히던 입덧이 차차 가라앉기 시작했어요.\n\n이런 찬스를 놓칠 수 없죠.\n\n하지만 체중조절을 위해 식단 관리는 필수라는 사실!\n\n아내의 입맛에 맞는 음식들을 준비하되, 영양소 균형을 맞춰가며 과식하지 않도록 남편이 도와주세요.\n\n스스로 자제하기 힘든 아내를 대신해, 남편의 도움이 절실하답니다.\n\n임신이라는 긴 마라톤의 페이스메이커가 되어주겠다는 결심, 잊지마세요!",
          },
        ],
      },
    },
    {
      week: 14,
      baby: {
        head: {
          title: "아기와 엄마가 탯줄로 단단히 연결되어 있어요!",
          discribed: "엄마의 주먹만 한 크기에요!",
          size: "약 9~10cm",
        },
        body: [
          {
            subTitle: "태반이 완성되었어요!",
            discribed:
              "태반이 완성되면 엄마의 몸과 아기의 몸이 탯줄로 연결왜요.\n\n탯줄을 통해 엄마와 아기가 연결되면서 영양분과 산소가 탯줄을 통해 아기에게 전달 된답니다.\n\n이제 태아의 신체기관은 더 빠른 속도로 발달될거예요.",
          },
          {
            subTitle: "몸 전체에 솜털이 나요!",
            discribed:
              "태아의 살결을 따라 소용돌이 모양으로 솜털이 나기 시작하며, 이 솜털이 몸 전체를 덮어요.\n\n솜털은 나중에 태아의 피부색과 피부를 보호하는 역할을 해요.",
          },
          {
            subTitle: "뇌가 발달하고 있어요!",
            discribed:
              "태아의 뇌가 좌뇌와 우뇌로 나뉘었어요!\n\n지금까지는 그냥 둥근 공모양이었던 뇌에 점점 주름이 생기면서 인간의 뇌의 형태가 되어가요.\n\n뇌가 형성되면서 신경이 세세하게 만들어지고 점점 성숙해지고 있어요.\n\n이제 태아는 많은 반사 반응이 가능해졌어요!",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 중기, 새로운 전환점!",
          discribed: "천천히 배가 불러오기 시작해요.",
        },
        body: [
          {
            subTitle: "아랫배가 나오기 시작해요",
            discribed:
              "자궁이 커지고 양수가 늘면서 아랫배가 나오기 시작해 이제 제법 임산부 태가 나기 시작해요.\n\n기존에 입덧 옷은 사이즈가 맞지 않아 불편할 수 있기 때문에 임부복을 추천해요.\n\n자궁이 커지면서 사타구니가 아프거나 골반이나 뼈에 무리가 갈 수 있기 떄문에 평소 바른 자세에 신경을 쓰는 것이 좋아요.",
          },
          {
            subTitle: "피부 트러블이 생길 수 있어요!",
            discribed:
              "호르몬의 영양으로 유두 주변, 겨드랑이, 허벅지 안쪽 등 피부색이 진갈색으로 변할 수 있어요.\n\n멜라닌 색소가 늘면서 기미가 올라오기도 하구.요\n\n이러한 피부 트러블은 출산 후 서서히 사라지기 시작하기 때문에 크게 염려하지 않아도 된답니다.",
          },
          {
            subTitle: "영양소를 골고루 섭취해야해요!",
            discribed:
              "태아가 빠르게 성장하는 시기이니만큼 충분한 영양소의 공급이 필수적이에요.\n\n한번에 많은 양을 먹기보다는 조금씩 자주, 천천히 드세요.\n\n충분한 수분 섭취도 잊지마세요!\n\n물은 하루에 8잔 이상 마시도록 노력해봐요.\n\n영양소의 공급은 중요하지만, 언제나 과식은 금물!\n\n체중 관리를 잊지마세요.\n\n체중 조절을 위해 매일 몸무게를 측정하고 기록하는 것은 중요하답니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "튼 살 관리는 미리미리!",
          discribed: "튼살 예방을 위해 마사지를 해봐요!",
        },
        body: [
          {
            subTitle: "튼 살, 지금부터 관리해볼까요?",
            discribed:
              "튼살은 임신 후기로 갈수록 급격히 팽창하는 아랫배나 가슴 부위에 주로 생겨요\n\n배를 중심으로 가슴, 엉덩이, 허벅지, 팔뚝 등 피부가 약하고 여린 부위에 잘 생기고 무릎이나 사타구니, 겨드랑이처럼 살이 접히는 부위에도 생기기 쉬워요.\n\n살은 아직 그 원인이 정확하지 않지만 일반적으로 튼살 발생의 가장 주요한 원인은 임신 중 체중 증가라고 알려져 있어요.\n\n튼살은 한번 생기면 쉽게 사라지지 않기 때문에 무엇보다 예방이 중요해요.\n\n따라서 배가 조금씩 나오는 임신 초기부터 튼살 오일이나 크림으로 관리하는 것이 좋아요.\n\n샤워 후 수건으로 물기를 살짝 닦은 상태에서 크림이나 오일을 바르고 마사지를 하면서 아내와 아기에게 사랑을 표현해보세요!\n\n매아침에는 유분이 적고 흡수가 잘되는 로션 타입이 좋고 저녁에는 유분이 풍부한 크림 타입의 제품을 바르면 도움이 된답니다.",
          },
        ],
      },
    },
    {
      week: 15,
      baby: {
        head: {
          title: "열심히 꼼지락 꼼지락!",
          discribed: "아보카도만 한 크기에요!",
          size: "약 10cm (100g)",
        },
        body: [
          {
            subTitle: "근육을 움직일 수 있어요!",
            discribed:
              "이 시기에 초음파를 찍어보면 태아의 다양한 행동을 생생하게 볼 수 있어요.\n\n근육이 발달하면서 태아가 주먹을 꽉 쥐기도 하고, 눈을 가늘게 뜨거나 눈살을 찌푸리기도 해요.\n\n발차기를 하거나 손가락 발가락을 오므리고 팔다리를 열심히 움직이기도 한답니다.",
          },
          {
            subTitle: "성별을 구분할 수 있어요!",
            discribed:
              "태아의 외부 생식기가 거의 완성되므로 초음파 검사로 아기의 성별을 확인 할 수도 있어요.\n\n하지만 이 시가 된다고 꼭 성별을 확인할 수 있는것은 아니랍니다.\n\n태아의 자세가 애매하거나 가려진 경우, 성별을 판별할 수 없을 수도 있어요.\n\n이런 경우에는 20주차 쯤에 진행하는 정밀 초음파 검사를 통해 확실하게 확인할 수 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "체중이 본격적으로 늘어나요!",
          discribed: "점점 완전한 D라인에 가까워지고 있어요.",
        },
        body: [
          {
            subTitle: "아랫배가 눈에띄게 나와요!",
            discribed:
              "자궁이 점점 커지면서 골반쪽에 위치해있던 자궁이 위로 올라와 아랫배가 나오게 돼요.\n\n자궁이 올라감에따라 방광을 누르던 압력이 사라져 빈뇨 증상은 완화되지만, 심장쪽으로 돌아오는 혈관을 눌러 하지의 혈액순환이 원활하지 못하기 때문에 다리가 붓고 쥐가 나기도 해요.\n\n또, 자궁이 커지면서 자궁을 받치는 인대가 늘어나 복부나 사타구니에 통증이 느껴질 수 있어요.\n\n복부의 통증은 주로 갑자기 움직일때 나타나므로, 몸을 움직일땐 천천히 움직이는게 좋아요.\n\n격렬한 운동이나 무리한 활동은 자궁 수축의 위험이 있으니 주의하세요!",
          },
          {
            subTitle: "기초체온이 낮아져요!",
            discribed:
              "임신후 올라갔던 체온이 점차 내려가기 시작해 출산할 때까지 낮아진 상태를 유지해요.\n\n또, 몸이 어느 정도 임신에 적응되어 임신 초기에 느꼈던 나른함이 없어지고, 불안하고 초조했던 마음도 점차 안정을 되찾게 돼요.",
          },
          {
            subTitle: "잇몸이 약해져요!",
            discribed:
              "여성호르몬의 양이 증가해 혈관 벽에 변화를 일으켜 잇몸이 붉어지거나 붓고 염증을 유발해요.\n\n또, 잇몸이 자극에 약해져 적은 양의 플라그나 치석으로도 쉽게 염증이 생길 수 있어요.\n\n잇몸이 암적색으로 변하고 부종과 출혈이 일어나기도 해요.\n\n오랜 수면시간도 치아 건강에 좋지 않아요.\n\n임신후에는 쉽게 피로해져 잠을 오래 자게되는데,. 수면 중엔 침 분비량이 줄어 구강 내 세균이 서식하기 좋은 환경이 돼요.\n\n또한 입덧으로 인한 구토로 입 안 산도가 높아지면서 치아가 부식돼 충치균이 번식하기 쉬워져요\n\n치과 치료는 초기와 후반기에 비해 비교적 안정기라 할 수 있는 임신 2기(14주~28주)가 적기이므로, 치과치료가 필요한 상황이라면 지금 바로 치료를 받도록 해요!",
          },
          {
            subTitle: "두번째 기형아검사를 진행해요!",
            discribed:
              "16주 전후로 2차 기형아 검사를 진행하게 돼요.\n\n2차 기형아 검사는 다운증후군 등의 염색체 이상에 대한 검사예요.\n\n검사에서 이상소견이 발견된다면 추가적인 검사가 진행될 수도 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "부부사이의 소통이 중요해요!",
          discribed: "심도깊은 이야기를 나누어보세요.",
        },
        body: [
          {
            subTitle: "남편의 소외감",
            discribed:
              "아내가 임신을 하게 되면 아내는 물론 가족과 친구들의 관심까지도 자연스럽게 태아에게쏟아지게 돼요.\n\n남편도 아내의 임신사실이 너무 기쁘지만, 때때로 남편은 홀로 떨어진 느낌을 받기도 한답니다.\n\n이러한 감정은 10달간의 임신기간동안 계속해서 느껴질 수 있어요.\n\n이러한 사실을 남편도, 아내도 미리 인지하고 있다면 건강한 임신기간을 보내는데 큰 도움이 될 수 있어요.\n\n부정적인 감정이 쌓여 두 사람 사이에 스트레스가 되지 않도록, 솔직한 대화를 나누는 것이 중요해요.\n\n둘만의 오붓한 시간을 보내며 자연스럽게 남편이 느끼는 감정들을 솔직하게 털어놓아보세요.\n\n남편의 솔직한 심정을 듣게 된 아내는 남편에 대해 더 깊이 이해할 수 있게 될거예요.\n\n또, 앞서 임신을 이미 경험해 본 주변의 선배 아빠들에게 조언을 구하는 것 역시 좋은 방법이 될 수 있답니다.",
          },
        ],
      },
    },
    {
      week: 16,
      baby: {
        head: {
          title: "아기는 지금 열심히 움직이는 중!",
          discribed: "참외만 한 크기에요!",
          size: "약 11~12cm (140g)",
        },
        body: [
          {
            subTitle: "활발하게 움직여요!",
            discribed:
              "이 시기는 태아가 활발하게 움직이는 시기로 머리를 흔들거나 손발을 움직여요.\n\n이제 자궁은 태아가 움직일 공간이 충분하기 때문에 태아는 헤엄치듯 팔다리를 움직이며 근육과 골격을 발달시켜요.\n\n또, 빛에 대한 민감성을 보이며 숨쉬기의 전 단계인 딸꾹질을 합답니다.\n\n하지만 태아의 기관은 공기가 아닌 액체로 차 있기 때문에 딸꾹질 소리를 들을 수는 없어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "안정기에 접어들었어요!",
          discribed:
            "입덧과의 작별을 기뻐하며, 활기차게 움직이는 아기처럼 엄마도 활기차게 지내봐요!",
        },
        body: [
          {
            subTitle: "완전한 임산부의 모습!",
            discribed:
              "16주에 접어들면서 이제 한눈에 봐도 알 수 있을 만큼 배가 불러와요.\n\n물론, 배가 불러오는 정도에는 개인차가 있기 때문에 아직까지 크게 티가 나지 않는 엄마들도 있답니다.\n\n배가 불러옴에따라 앞쪽 배에 무게가 더해져 허리가 아플 수 있어요.\n\n바른 자세를 유지하려 신경써주세요.\n\n가벼운 운동과 스트레칭은 허리를 보호하는데 도움이 된답니다!",
          },
          {
            subTitle: "이제는 정말 안정기, 하지만 방심은 금물!",
            discribed:
              "태반이 완전히 완성되어 안정적으로 정착함에따라 유산의 위험은 이제 거의 사라졌어요.\n\n엄마를 힘들게 하던 임신 초기의 증상들도 많이 가라앉아 컨디션도 좋아졌구요.\n\n하지만 방심은 금물!\n\n증상이 사라졌다고 해서 과격한 운동이나 무리를 해도 된다는 뜻은 아니예요.\n\n아기에게 스트레스를 줄 수 있고, 자궁 수축을 유발할 수 있어요.\n\n안정기라고 하더라도 항상 조심, 또 조심! 잊지마세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "안정기에 접어들면, 부부관계를 가져도 괜찮아요!",
          discribed: "관계시 배를 누르지 않도록 주의가 필요해요.",
        },
        body: [
          {
            subTitle: "임신 중 성관계, 괜찮을까요?",
            discribed:
              "임신 초기(1~12주)에 과격한 성생활을 하면 자궁 수축을 유발해 유산이 될 수 있어요.\n\n임신 후 1달 동안은 수정란이 자궁 안에 착상한 지 얼마 되지 않아 불안정한 상태이기 때문에 생활을 하지 않는 것이 좋아요.\n\n임신 중기(13~27주)는 입덧이나 피로감이 사라지고 몸과 마음이 안정되는 시기이기 때문에 비교적 안전해요.\n\n하지만 자궁이 커지고 배가 불러오는 시기이기 때문에 남편의 체중으로 배를 누르는 것은 위험해요.\n\n배를 누르지 않는 체위로 관계를 갖도록 해주세요.\n\n임신 후기(28~40주)가 되면 자궁 입구와 질이 부드러워지고, 이따금 배가 당기거나 질 분비물이 늘어나는 등 출산 준비가 시작돼요.\n\n이 시기에는 작은 자극으로도 질이 상처받기 쉬우며 갑자기 자궁이 수축을 일으키기도 해요.\n\n임신 후기의 성생활은 조기 파수나 감염, 조산의 원인이 될 수 있으므로 특히 주의해야 해요.\n\n특히 조산을 예방하기 위해서 임신 막달 동안은 절대 성생활을 피해야 해요.\n\n임신 중 성관계시 다음 주의사항을 지켜주세요!\n\n- 유두 자극하지 않기\n유두를 자극하면 자궁 수축을 유발하는 옥시토신이라는 호르몬이 분비돼 조산이나 유산의 원인이 될 수 있어요.\n\n- 외음부 감염 주의하기\n임신 중에는 질 내 산성도가 낮아지고 면역력이 약해져 쉽게 세균에 감염될 수 있어요.\n따라서 관계 시 부부 모두 몸을 깨끗이 하고 질 내에 손을 넣는 행위나 구강성교는 자제하도록 해요.\n\n- 반드시 콘돔 착용하기\n남성의 정액에는 프로스타글란딘이라는 호르몬이 있는데, 이는 자궁 수축을 일으킬 수 있어요.\n또한, 세균 감염 예방을 위해서라도 콘돔을 사용하는 편이 안전해요.",
          },
        ],
      },
    },
    {
      week: 17,
      baby: {
        head: {
          title: "신경이 발달하고, 태어나기 위한 준비를 해요!",
          discribed: "사과만 한 크기에요!",
          size: "약 13cm (160g)",
        },
        body: [
          {
            subTitle: "청각 기관이 발달해요!",
            discribed:
              "태아의 청각 기관이 크게 발달해요!\n\n귓속의 작은 뼈가 단단해지기 시작하면서 소리를 듣기 시작하해요.\n\n태아는 이제 엄마의 목소리나 심장 뛰는 소리, 소화 기관에서 나는 소리 외에 엄마 배 밖에서 나는 소리도 어느 정도는 들을 수 있어요.\n\n어떤 소리를 듣느야에 따라 태아의 기분도 달라질 수 있답니다.",
          },
          {
            subTitle: "태아는 열심히 연습중!",
            discribed:
              "태반을 통해 산소를 공급 받는다\n\n임신 17주째 태아의 순환계와 비뇨기계는 열심히 제 역할을 하고 있어요.\n\n필요한 산소는 태반을 통해서 공급받고, 양수를 들이마셨다 내뱉었다 하면서 숨을 쉰답니다.\n\n이 과정을 통해 소화기 계통이 발달하게 돼요.\n\n태아는 지금 열심히 태어날 준비를 하고있어요!",
          },
        ],
      },
      mom: {
        head: {
          title: "몸무게가 자꾸자꾸 늘어나요!",
          discribed:
            "태반이 완성되면서 아기가 빠르게 성장하기 떄문에 몸무게가 늘어는 속도도 빨라져요.",
        },
        body: [
          {
            subTitle: "태동이 느껴져요!",
            discribed:
              "이 시기에 처음 태동을 느낀 산모는 이게 태동인지 아닌지 헷갈릴 수 있어요.\n\n흔히 물방이 뽀글뽀글하는 느낌, 장이 꾸르륵 거리는 느낌으로 태동을 표현하기도 한답니다.\n\n임신 5개월 차부터는 이런 태동이 뚜렷해져요.",
          },
          {
            subTitle: "급격한 체중 증가!",
            discribed:
              "보통 임신 13주에서 16주 사이 입덧이 완화되면서 식욕이 급격하게 늘게 돼요.\n\n물론 개인에 따라 20주까지도 입덧을 하는 경우도 있답니다.\n\n급격한 체중 증가는 산모나 태아 모두에게 좋지 않아요.\n\n지나친 야식은 피하고, 정해진 식사 시간을 정해 균형 있는 식단으로 건강을 꼭 챙기세요.\n\n한 달에 2kg 이상 늘지 않도록 신경써서 조절해요!",
          },
          {
            subTitle: "변비가 심해져요!",
            discribed:
              "임신 중 입덧으로 인해 수분 공급이 감소하고, 상대적인 운동량이 부족해지며 프로게스테론의 영향으로 장운동이 감소하기 때문에 변비가 잘 발생해요.\n\n또한 임신이진행되면서 뱃속에서 자궁이 차지하는 부피가 상대적으로 커져감에 따라 음식물이 소장을 통과하는 시간이 지연되고 대장에서도 근육이 이완되어 대장 내용물의 정체기간이 길어져 변비가 흔히 발생해요.\n\n이러한 변비를 예방하기 위해서는 규칙적인 식사와 풍부한 섬유질의 섭취가 중요해요.\n\n변비 증상의 악화로 변비약을 사용하고 싶다면 반드시 전문의와 상담하세요!",
          },
          {
            subTitle: "철분을 충분히 섭취해주세요!",
            discribed:
              "빈혈 증상이 없는 엄마에게도 충분한 철분 섭취는 필수!\n\n태아가 성장하기 위해서는 더 많은 혈액이 필요하기 때문에 철분을 충분히 공급해주어야 해요.\n\n철분의 흡수율을 높이기 위해서는 비타민C를 함께 섭취해주는 것이 좋아요.",
          },
        ],
      },
      dad: {
        head: {
          title: "정신없는 아내를 위해 미리미리!",
          discribed: "검사 일정을 확인하고 도와주세요.",
        },
        body: [
          {
            subTitle: "검사를 미리미리 챙겨요!",
            discribed:
              "요즈음 아내에게 필요한 검사가 부쩍 많아졌어요.\n\n정신없는 아내를 위해 남편이 먼저 나서서 아내를 도와주세요!\n\n검사 스케줄을 미리미리 확인하고, 아내가 잊지 않도록 확인해주세요.\n\n검사에 대한 두려움이나 불안함으로 아내가 힘들어한다면, 곁에서 힘이 되어주세요.",
          },
        ],
      },
    },
    {
      week: 18,
      baby: {
        head: {
          title: "근육이 붙으면서 움직임이 활발해져요!",
          discribed: "배만 한 크기에요!",
          size: "약 14~15cm (200g)",
        },
        body: [
          {
            subTitle: "본격적인 태동이 시작돼요!",
            discribed:
              "자궁 속에 태아가 움직일 공간이 충분하기 때문에 태아는 다양한 자세로 자유롭게 활동하기 시작해요.\n\n바깥세상의 자극에 민감해지며, 때로는 발로 차거나 찔러 자신의 존재를 엄마에게 알리기도 한답니다.",
          },
          {
            subTitle: "태지가 몸을 감싸요!",
            discribed:
              "태아의 피부 위로 얇은 기름막인 태지가 생성돼요.\n\n태지는 생긴 흰색 크림 형태의 물질로 피부에 보호막을 형성해 천연 보습제 역할을 해요.",
          },
        ],
      },
      mom: {
        head: {
          title: "아기가 움직이는 것을 느끼기 시작해요!",
          discribed: "아기가 함께하고 있다는 것 더 확실히 느낄 수 있어요.",
        },
        body: [
          {
            subTitle: "질 분비물이 증가해요!",
            discribed:
              "에스트로겐의 분비가 증가하면서 자궁의 움직임과 골반 내 혈액순환이 활발해지고, 질 분비물이 늘어나요.\n\n임신 중 질 분비물의 증가는 산도와 태아가 세균으로부터 감염되는 것을 방지하는 역할을 해요.\n\n임이는 자궁 환경이 변화함에 따라 나타나는 자연스러운 현상이므로 걱정하지 않아도 돼요.\n\n하지만 분비물의 양이 급격하게 많아지고, 악취나 가려움증을 동반하거나, 누런색 또는 녹색의 분비물이 나오는 경우에는 '질염'을 의심해야해요.\n\n임신 중에는 호르몬의 변화로 질 분비물이 증가하면서 세균이나 곰팡이가 번식하기 쉬운 환경이 조성되어 질염이 더 잘 발생할 수 있기 때문에 이런 증상이 보인다면 의사와 상담하도록 해요!",
          },
          {
            subTitle: "가슴에 변화가 생겻어요!",
            discribed:
              "엄마의 유선이 발달하면서 분비물이 나오고 유방이 급격히 커지기 시작해요.\n\n유방이 커지면서 일반 속옷이 맞지 않고 불편하게 느껴질 수 있기 때문에 임산부 브라 또는 수유 브라를 착용하는것이 좋아요.\n\n유두에서 분비물이 나올 경우 일부러 짜지 말고 거즈로 가볍게 닦아내도록 해요.",
          },
          {
            subTitle: "다리에 경련이 일어나요!",
            discribed:
              "임신 중에는 태아가 산모에게서 필요한 영양분을 공급받아 가기 때문에 산모는 칼슘, 마그네슘 같은 영양소가 부족해 혈액순환이 잘 되지 않아 다리 경련이 생기기도 해요.\n\n주로 종아리에 경련이 일어나게 되는데, 자기 전 종아리를 부드럽게 마사지해주거나 스트레칭을 꾸준히 해주면 다리 경련을 예방하는데 도움이 돼요.",
          },
          {
            subTitle: "심스자세",
            discribed:
              "심스 자세란 왼쪽으로 눕고 오른쪽 넙다리와 무릎을 들어 올리는 자세로, 배뭉침이나 요통을 완화시키고 혈액 순환이 원활해져 피로가 금방 풀리고 숙면을 유도하는 효과가 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아기에게 아빠의 목소리를 들려주세요!",
          discribed: "아기에게는 아빠의 목소리가 더 잘들려요.",
        },
        body: [
          {
            subTitle: "태동을 느끼며 아기와 대화를 해보세요!",
            discribed:
              "태아가 가장 발달한 감각은 청각!\n\n아빠의 낮은 목소리는 엄마보다 태아에게 더 잘 전달돼요.\n\n태아는 중저음의 아빠 목소리를 들으며 안정감을 느끼고, 교감을 통해 아빠와의 애착을 높일 수 있어요.\n\n뿐만아니라 태아의 두되는 소리를 듣기 시작하면서 어떤 소리를 듣게 되는지에 따라 두뇌 발달의 양상이 달라져요.\n\n아직 태어나지 않은 배 속의 아기에게 말을 거는것이 어색하게 느껴질 수 있지만, 아기의 뇌 발달을 위해 꾸준히 이야기를 나누어 보세요!\n\n태명 등의 애칭을 불러주면 더 좋겠죠?",
          },
        ],
      },
    },
    {
      week: 19,
      baby: {
        head: {
          title: "엄마 아빠의 목소리, 잘들려요!",
          discribed: "바나나 한 송이만 한 크기에요!",
          size: "약 16~17cm (250g)",
        },
        body: [
          {
            subTitle: "뇌가 크게 발달했어요!",
            discribed:
              "이제 태아는 뇌가 발달하여 엄마와 아빠 목소리를 기억할 수 있어요.\n\n특히 간뇌가 발달해 엄마의 감정 변화에 따라 반응할 수 있답니다.\n\n근육을 뇌에 연결하는 운동신경원이 발달하면서 태아는 자신의 의지대로 움직일 수 있어요.\n\n초음파로 보면 태아가 스스로 발로 차고, 구부리고, 뻗치고, 엄지손가락을 빠는 모습을 관찰할 수 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "엄마의 몸에는 계속해서 변화가 찾아와요!",
          discribed: "임신전에는 없었던 증상들이 확연하게 나타날 수 있어요.",
        },
        body: [
          {
            subTitle: "가슴에 변화가 생겼어요!",
            discribed:
              "호르몬의 변화로 유륜은 점차 더 넓어져요.\n\n피부의 색소 변화가 증가되어, 유두 색깔이 짙어지고 따끔거리기도 해요.\n\n아기에게 모유를 먹이기 위한 준비가 진행되면서 유두에서 유즙이 나오게 돼요.\n\n이때, 일부러 짜려고 하지 말고 거즈로 가볍게 닦아줍니다.",
          },
          {
            subTitle: "갑자기 코를 골아요!",
            discribed:
              "임신 전에는 코를 골지 않았는데, 임신을 하고부터 코골이를 시작하는 엄마들이 많아요!\n\n임신 후반기로 갈수록 태아의 성장과 함께 임산부의 체중도 늘어나게 되는데, 갑자기 늘어난 체중은 기도의 호흡을 방해해 코골이를 유발하기 때문이에요.\n\n또, 체중증가는 혈류와 혈압의 증가를 유발시켜 코점막에 충혈을 발생시키기도 한답니다.\n\n심한 코골이가 수면 무호흡증으로 이어진다면 산모와 태아의 건강을 위협할 수 있어요.\n\n수면 무호흡증은 수면을 방해할 뿐만 아니라 저산소증을 유발할 수 있기 때문에 주의해야 해요.\n\n따라서 수면 무호흡증이 심하다면 방치하지 말고 병원을 방문해 전문적인 검사를 받는 것을 권장합니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "빠르게 변화하는 아내의 몸, 남편의 서포트가 중요해요!",
          discribed: "아내가 잘 적응할 수 있도록 곁에서 지지해주세요.",
        },
        body: [
          {
            subTitle: "최고의 태교는 아내의 행복!",
            discribed:
              "아기의 태동은 날로 강해지고, 배는 빠른속도로 부풀어 오르고 있어요.\n\n이 시기의 태아는 간뇌가 발달해 엄마의 감정을 함께 느낄 수 있답니다.\n\n가장 좋은 태교는 엄마를 행복하게 해주는 거예요.\n\n어느덧 40주간의 여정의 절반을 향해 달려가고 있어요.\n\n하루가 다르게 바뀌어가는 몸으로 고생하는 엄마와 열심히 태어날 준비를 하고있는 아기를 위해 힘내요, 아빠!",
          },
        ],
      },
    },
    {
      week: 20,
      baby: {
        head: {
          title: "감각기관 발달의 절정!",
          discribed: "당근만 한 크기에요!",
          size: "약 24cm (300g)",
        },
        body: [
          {
            subTitle: "모든 감각기관이 활발하게 발달해요!",
            discribed:
              "태아의 감각 기관 발달이 극에 달하는 시기로, 모든 감각 기관의 신경세포가 발달해요.\n\n이 시기가 지나면 태아는 사람이 갖추어야 할 신경세포를 모두 갖추고, 이후로는 신경세포의 크기가 커지고 더욱 복잡해져요.",
          },
          {
            subTitle: "성별을 확실히 알 수 있어요!",
            discribed:
              "15주차에 태아의 성별을 정확하게 확인하지 못했었나요?\n\n이제 정밀 초음파를 통해 확실하게 확인 할 수 있어요!",
          },
        ],
      },
      mom: {
        head: {
          title: "쉽게 붓고 뻐근해지는 하반신!",
          discribed: "자궁이 커지면서 혈액순환에 어려움이 생겨요.",
        },
        body: [
          {
            subTitle: "이제 절반이 지나갔어요!",
            discribed:
              "40주간의 긴 마라톤의 반환점을 돌았네요!\n\n정말 수고 많았어요, 씩씩하게 이겨낸 스스로를 있는 힘껏 칭찬해주세요.",
          },
          {
            subTitle: "부종과 하지정맥류",
            discribed:
              "이 시기엔 다리와 발이 쉽게 붓곤 해요.\n\n자궁이 커지면서 복부안의 하대정맥을 눌러 혈액 순환이 잘 안되고 다리에서 심장으로 올라가는 순환장애 때문이에요.\n\n또, 임신과 관련된 호르몬의 균형이 변하면서 혈관 벽이 느슨하게 약화되고 정맥 혈관 내부 압력이 증가하게 되면 정맥 혈관이 팽창하게 돼요.\n\n이로 인해 작은 모세관의 확장 또는 굵은 정맥 혈관이 튀어나오는 하지정맥류가 발생할 수 있어요.\n\n이러한 증상을 완화하기 위해서는 오래 앉아 있는 것을 피하고, 앉아서 일하는 경우 1시간에 10분 정도는 가볍게 걸어주는 것이 좋아요.\n\n쉴 때 다리를 심장보다 약간 높이 올리거나 압박스타킹을 착용하는 것도 좋은 방법이에요.",
          },
          {
            subTitle: "배꼽이 튀어나올 수 있어요!",
            discribed:
              "자궁의 크기가 커지면서 복부를 압박해 배꼽이 밖으로 튀어나올 수 있어요.\n\n이는 자연스러운 현상이고 출산 후에 다시 들어가니 너무 걱정하지 않아도 돼요.",
          },
        ],
      },
      dad: {
        head: {
          title: "우리 아기는 어떻게 생겼을까요?",
          discribed: "아기의 얼굴을 확인해요!",
        },
        body: [
          {
            subTitle: "아기의 얼굴을 볼 수 있어요!",
            discribed:
              "이제 정밀 초음파와 3D 초음파를 통해 아기의 얼굴을 볼 수 있어요!\n\n아기의 얼굴과 몸을 아주 선명하게 확인 할 수 있답니다.\n\n얼굴에 자주 나타나는 구순구개열이나 손가락과 발가락의 이상 여부 등을 확인 할 수도 있어요.\n\n처음으로 자세히 들여다보는 아기의 얼굴, 감동적이지 않으신가요?\n\n이 순간의 감동을 기록으로 남겨보세요!",
          },
        ],
      },
    },
    {
      week: 21,
      baby: {
        head: {
          title: "골격은 완전히 자리잡았지만, 피부는 아직...",
          discribed: "멜론만 한 크기에요!",
          size: "약 25cm (380g)",
        },
        body: [
          {
            subTitle: "맛을 느낄 수 있어요!",
            discribed:
              "태아는 미각 봉우리를 가져 양수의 맛을 느낄 수 있어요.\n\n양수는 엄마가 먹은 음식에 따라 맛이 변한답니다.\n\n또, 이 시기부터는 태아의 소화 기관이 발달해 삼킨 양수로부터 물과 당분을 흡수해요.\n\n이렇게 양수를 삼킴으로써 태아의 소화 기관이 점점 발달하게 돼요.",
          },
          {
            subTitle: "아직은 쪼글쪼글...",
            discribed:
              "태아의 피부는 붉은빛이 돌지만 아직은 반 투명한 상태예요.\n\n피하지방이 부족해 피부가 쪼글쪼글 주름진 상태랍니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "빠르게 늘어나는 체중과 부풀어오르는 배!",
          discribed:
            "갑자기 늘어난 몸무게와 급격히 커진 자궁으로 몸 가누기가 힘들어져요.",
        },
        body: [
          {
            subTitle: "숨쉬기가 힘들어요!",
            discribed:
              "임신 중기가 되면 호흡도 깊어지고, 조금만 움직여도 숨이 찰 정도로 힘들어져요.\n\n자궁이 폐를 향해 위로 올라가면서 폐를 압박하기 때문이에요.\n\n뿐만 아니라 임신 중에는 갑상선이 활발하게 활동하기 때문에 임신 전보다 땀을 많이 흘리게 돼요.\n\n심하게 몸을 움직이거나 높은 곳을 오르는 일은 가급적 삼가고, 충분히 휴식을 취하도록 해요.",
          },
          {
            subTitle: "배 뭉침이 있어요!",
            discribed:
              "자궁이 점점 커지면서 수축하려는 힘도 생기기 시작하시 때문에 하루에 2~3회 정도 불규칙적인 자궁수축이 있을 수 있어요.\n\n이런 현상을 '배가 뭉친다'라고 표현해요.\n\n자궁수축 이외에, 태동이 심할 경우에도 일시적으로 짧은 수축감을 느낄 수 있어요.\n\n배가 뭉칠 때 통증을 함께 느끼는 경우도 있는데 배 뭉침으로 인한 통증은 사람에 따라 개인차가 있어요.\n\n하지만 너무 자주 배가 뭉치거나 통증이 심하다면 고민하지 말고 내원하여 진료를 보도록 해요.",
          },
          {
            subTitle: "누구나 불안하답니다.",
            discribed:
              "하루가 다르게 배가 불러오고, 태동은 점점 더 강하게 느껴지고...\n\n불안함과 두려움을 느끼는 건 너무나도 당연한 일이에요.\n\n임신 과정을 겪으면서 느끼는 불안한 감정들을 인정하고, 자연스럽게 받아들이는 자세가 필요해요.\n\n먼저 임신을 경험한 다른 친구에게 고민을 털어놓는 건 어떨까요?\n\n일기를 통해 불안한 마음을 정리해 보는 것도 좋은 방법이에요.\n\n지금 불안한 마음을 느끼는 건 엄마 뿐 아니라 아빠도 마찬가지예요.\n\n남편과 함께 깊은 대화를 나누며 불안한 마음을 나누어가지고 서로를 이해하는 시간을 가져보세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "남편의 따뜻한 말 한마디가 큰 힘이 되어요!",
          discribed: "혼란스러울 아내를 다독여주세요.",
        },
        body: [
          {
            subTitle: "신체적인 변화로 혼란스러워하는 아내를 위해...",
            discribed:
              "임신 기간의 절반 지점을 넘어서면서, 아내의 몸에는 많은 변화들이 빠르게 나타나고 있어요.\n\n이런 변화들이 나타남에 따라 아내의 일상도 바뀌어 가요.\n\n예전에는 아무렇지 않게 할 수 있던 일들이 이제는 혼자서 할 수 없게 되기도 하고, 갑작스런 신체의 변화는 낯설게만 느껴져요.\n\n이렇게 혼란스러워 하는 아내가 안정을 되찾기 위해서는 남편의 역할이 중요해요!\n\n아내의 곁에서 정서적인 지지를 제공해 주세요.\n\n행동의 제약이 생긴 아내를 돕고, 아내의 변한 몸 역시도 얼마나 아름다운지 반복해서 말해주세요.\n\n남편의 이런 따뜻한 말들이 아내가 임신 기간을 이겨내는 큰 힘이 된답니다.",
          },
        ],
      },
    },
    {
      week: 22,
      baby: {
        head: {
          title: "이제는 아기도 밝고 어두운 것을 구별할 수 있어요!",
          discribed: "양배추만 한 크기에요!",
          size: "약 27~28cm (500g)",
        },
        body: [
          {
            subTitle: "밤과 낮을 구분할 수 있어요!",
            discribed:
              "이제 태아는 밤과 낮을 구분할 수 있을 정도로 빛을 느낄 수 있어요.\n\n엄마가 규칙적인 생활을 하면 태아도 함께 규칙적안 생활리듬을 갖게 돼요.",
          },
          {
            subTitle: "눈썹과 눈꺼풀이 발달해요!",
            discribed:
              "태아의 눈꺼풀과 눈썹이 거의 완전히 자라고, 손톱도 길게 자라 손가락 끝을 덮어요.",
          },
          {
            subTitle: "골격과 관절이 발달해요!",
            discribed:
              "이제 태아의 골격이 완전히 잡혀요.\n\n엑스선을 찍어 보면 두개골, 척추, 갈비뼈, 팔다리뼈를 모두 뚜렷이 구분할 수 있어요.\n\n관절도 상당히 발달해 태아는 스스로 얼굴을 쓰다듬고 팔다리를 만지작거리며, 손가락을 빨거나 고개를 숙이기도 해요.",
          },
        ],
      },
      mom: {
        head: {
          title: "몸이 점점 둔해지는 느낌!",
          discribed: "배가 불러오면서 몸은 둔해지고, 동작이 서툴러져요!",
        },
        body: [
          {
            subTitle: "몸을 가누기가 힘들어져요!",
            discribed:
              "배가 많이 불러 몸의 균형을 잡기 어렵고 동작이 서툴러져요.\n\n균형을 잡기 위해 무의식적으로 몸을 뒤로 젖히는 자세를 취하게 돼 요통을 호소하기도 해요.\n\n넘어질 위험이 큰 시기이기 때문에 각별히 주의해주세요.\n\n편안한 신발을 신고, 미끄럽거나 어두운 곳 또는 계단과 같은 장소에서는 특히 조심해야해요.\n\n혹시 균형을 잃고 넘어지더라도 배로 세게 넘어진 게 아니라면 크게 걱정하지 않아도 돼요.\n\n태아는 양수박에 싸여 보호되고 있으니까요.\n\n하지만 넘어진 후에 배뭉침이 심해지거나 평소와는 다른 통증이 있다면 반드시 내원하여 담당의와 상담하세요.",
          },
          {
            subTitle: "자궁경관무력증이란?",
            discribed:
              "자궁경관무력증은 자궁경관의 구조나 기능에 결함이 있어 진통 없이 자궁경부가 열려 임신 28주 이전에 태아가 나오는 경우를 말해요.\n\n원인은 정확하지 않은데, 자궁경부의 선천적인 이상, 과거의 분만 및 유산시술로 인한 자궁경부의 손상,수술과 관련된 외상 등의 다양한 원인이 있어요.\n\n보통 임신 20~25주 전후에 발생할 수 있는데,배가 자주 뭉치거나 갑자기 냉이 많아지면서 이슬같은 피가 비치고, 양막이 불룩하게 질로 나온 것이 보이는 등의 증상이 동반돼요.",
          },
        ],
      },
      dad: {
        head: {
          title: "변화하는 엄마와 함께 아빠도 변화를!",
          discribed: "엄마의 변화에 발빠른 적응이 필요해요.",
        },
        body: [
          {
            subTitle: "변화는 태아 건강의 증거!",
            discribed:
              "임신의 과정이 진행됨에 따라 엄마의 몸이 변하는 것은 선택이 아닌 필수불가결한 것.\n\n변하지 않는다면 새로운 생명을 만날 수 없어요.\n\n엄마의 변화는 태아 건강의 증거예요.\n\n엄마만 변해서는 안되죠, 아빠도 그에 발맞춰 계속해서 더 든든한 존재로 변화해야 해요.\n\n엄마가 가장 믿고 의지할 수 있는 소중한 내편이 되어주세요.\n\n아기가 태어난 이후의 삶을 상상해 보세요.\n\n곧 태어날 아기를 생각하면서 엄마와 함께 씩씩한 발걸음을 내딛어봐요!",
          },
        ],
      },
    },
    {
      week: 23,
      baby: {
        head: {
          title: "아기의 모습이 어느덧 신생아와 흡사해졌어요!",
          discribed: "가지만 한 크기에요!",
          size: "약 29~30cm (530g)",
        },
        body: [
          {
            subTitle: "심장박동이 강해져요!",
            discribed:
              "이제는 청진기로도 태아의 심장 소리를 들을 수 있어요.\n\n청력이 발달하여 자궁 밖에서 나는 모든 소리를 듣는 것이 가능해, 너무 시끄럽고 큰 소리는 싫어한답니다.",
          },
          {
            subTitle: "신체와 얼굴에 균형이 잡혀요!",
            discribed:
              "지방질이 많지 않아 아직 피부가 주름져 있지만, 태아의 모습이 어느새 신생아와 비슷해졌어요.\n\n입술의 구분이 뚜렷해지며, 눈 또한 어느 정도 발달해 있어요.\n\n눈썹과 눈꺼풀은 자리를 잡았고, 잇몸선 아래에는 치아의 싹이 트고 있어요.\n\n이제는 단순한 근육의 움직임이 아니라, 자극에 대한 반응으로써 표정을 지을 수 있게 됐답니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 후 찾아온 치질과 가려움증!",
          discribed: "임신 전에는 없었던 증상들이 나타날 수 있어요.",
        },
        body: [
          {
            subTitle: "치질이 생길 수 있어요!",
            discribed:
              "임신 주수가 진행되면서 증가한 황체 호르몬의 영향으로 대장 근육이 이완되어 운동능력이 저하되면서 음식물이 계속 대장에 머물게 되어 변비가 생겨요.\n\n이로인해 배변시 힘을 주는 시간이 길어지면 항문에 부담이 가해지며 치질이 발생해요.\n\n치질을 예방하기 위해서는 우선 변비를 예방하고 그 증상을 개선해야 해요.\n\n변비 예방을 위해서는 충분한 섬유소와 수분섭취를 통하여 배변을 부드럽게 하도록 하고 적당한 운동을 함으로써 장운동의 활동성을 유지할 수 있도록 하는 것이 중요해요.\n\n식사는 하루 세 끼를 꼭 챙겨먹고 무엇보다 식이섬유가 함유된 음식 위주로 식단을 짜 섭취량을 늘려야 해요.\n\n또한 수분을 충분히 섭취해주세요.\n\n1~2도의 가벼운 치핵 증상은 따뜻한 물로 좌욕하면 혈액순환이 좋아져서 증상이 조금 완화될 수 있어요.",
          },
          {
            subTitle: "임신 소양증이란?",
            discribed:
              "임신 소양증은 임신 중기에 주로 발생하는 피부 가려움증이에요.\n\n임신 소양증의 정확한 원인은 아직 정확하게 밝혀지지 않았지만, 태반에서 나오는 호르몬 혹은 임신 중 증가한 땀으로 인해 가려움증이 동반된다고 추정하고 있어요.\n\n피부가 건조하면 증상이 더욱 심해지므로 물로만 몸을 씻거나 보습제를 충분히 발라줄 수 있도록 하고, 순면 소재의 옷을 입는 것이 좋아요.\n\n수시로 물을 마겨 수분을 보충하는 것도 중요해요.\n\n출산 후 자연스레 증상이 사라지고 태아에게도 악영향을 끼치지 않기에 크게 걱정할 필요는 없지만, 잠을 제대로 못 잘 정도로 증상이 심하거나 피부가 벗겨질 정도라면 전문의의 상담을 통해 적절한 치료를 받을 수 있도록 해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "태교여행을 계획해보세요!",
          discribed: "둘만의 시간을 보내보아요.",
        },
        body: [
          {
            subTitle: "둘만의 시간을 계획해 보세요!",
            discribed:
              "임신 후기와 출산 직후 한동안은 아내와 둘만의 낭만적인 시간을 갖기 어려울 거예요.\n\n임신 후기로 갈수록 거동이 불편해지고, 출산 직후에는 산후조리를 해야 하니까요.\n\n거창한것이 아니어도 좋아요!\n\n둘만의 소소하지만 낭만적인 시간을 계획해보세요.\n\n가까운 곳으로 떠나는 가벼운 여행도 좋아요.\n\n아내가 좋아하는 음식을 먹고, 감동적인 영화를 한편 보는 것도 좋을 것 같네요.",
          },
        ],
      },
    },
    {
      week: 24,
      baby: {
        head: {
          title:
            "일찍 태어나더라도 생존을 기대할 수 있는 최소한의 주수에 도달했어요!",
          discribed: "농구공만 한 크기에요!",
          size: "약 31cm (600g)",
        },
        body: [
          {
            subTitle: "폐 속의 혈관이 발달해요!",
            discribed:
              "호흡을 위한 준비로 폐 속의 혈관이 발달해요.\n\n납작하게 열리지 않던 폐포를 태아의 첫 호흡으로 열게 하는 계면활성물질을 분비할 수 있는 주수이기 때문에, 이번 주부터는 아기가 태어나더라도 자발적인 호흡을 할 수 있어요.\n\n다시말해, 조산이라도 최소한 24주를 넘겨야 생존을 기대할 수 있다는 이야기이기도 해요.\n\n입을 자주 벌려 양수를 마시고 뱉으면서 숨쉬는 연습을 해요.\n\n탯줄이나 손가락이 입 근처에 있으면 반사적으로 얼굴을 그쪽으로 돌리는 모습을 보이기도 해요.\n\n이런 과정을 통해 태아는 태어난 뒤 배가 고프면 엄마의 젖꼭지를 찾는 먹이 반사를 익히게 된답니다.",
          },
          {
            subTitle: "바깥 소리에 더욱 민감해져요!",
            discribed:
              "이제 태아는 바깥에서 들리는 소리에 더욱 민감해지고, 웬만한 소리에도 익숙해진다.\n\n이렇게 이미 엄마의 뱃속에서부터 외부 세계를 접하기 때문에, 태어난 후에 일상의 소음에 크게 놀라지 않게 된는거랍니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "어느덧 임신한 지 만 6개월!",
          discribed: "자궁이 배꼽까지 올라오고, 배와 가슴이 많이 커졌어요!",
        },
        body: [
          {
            subTitle: "임신성 당뇨 검사란?",
            discribed:
              "임신 24주에서 28주 사이에는 병원에서 포도당 검사를 받아야 해요.\n\n임산부에게 생길 수 있는 고혈당 상태인 임신성 당뇨병을 체크하기 위해서예요.\n\n임신성 당뇨병은 흔히 볼 수 있는 임신 합병증으로 다른 당뇨병과 달리 아기가 태어나면 대부분 없어지지만, 임신 중에는 태아나 산모의 건강을 해칠 수 있기 때문에 조심해야 해요.\n\n임신 전에 당뇨병이 없었다고 하더라도 임신 후에 생길 수 있으므로 반드시 검사를 해야해요.\n\n임신성 당뇨병을 예방하기 위해서는 체중의 조절과 건강한 식단, 주기적인 운동이 중요해요.",
          },
          {
            subTitle: "다리가 저리고 쥐가 나요!",
            discribed:
              "체중이 많이 증가하면서 몸을 지탱하는 다리에 무리가 가기 때문에 다리의 근육의 피로가 심해져요.\n\n불러오는 배가 대퇴부 정맥을 압박해 다리에 쥐가 나거나 저리기도 하지요.\n\n이런 증상은 특히 밤에 잠을 자다가 많이 일어나는데, 갑작스런 다리 통증으로 잠에서 깨는 일도 빈번해요.",
          },
          {
            subTitle: "양치할때 피가 나요!",
            discribed:
              "임신 중에는 호르몬 분비로 잇몸이 부어올라 이를 닦을 때 쉽게 피가 나요.\n\n따라서 되도록 부드럽게 양치질을 하는 것이 중요하답니다.\n\n잇몸 출혈 외에 코막힘이나 코피 등의 증상이 나타나기도 해요.\n\n임신 중에 잇몸 관리를 제대로 하지 않으면, 잇몸에 염증이 생기는 임신성 치은염에 걸리기 쉬워요.\n\n치은염으로 염증수치가 높아진 혈액은 태아에게 나쁜 영향을 끼칠 수 있어요.\n\n따라서 안전하게 치과치료를 받을 수 있는 임신 중기에 적극적으로 치과를 통해 예방치료를 받는 것이 좋아요.",
          },
          {
            subTitle: "조산을 조심해요!",
            discribed:
              "혹시라도 예상치 못하게 아기가 일찍 태어나더라도, 외부의 도움이 있다면 생존할 수 있는 최소한의 주수에 도달했어요.\n\n지금까지는 유산을 조심해왔다면 이제부터는 조산을 예방할 수 있도록 주의해야 해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "한발 빠르게 도움의 손길을!",
          discribed: "아내에게 필요한게 무엇일지 자세히 살펴보세요.",
        },
        body: [
          {
            subTitle: "아내는 도움이 필요해요!",
            discribed:
              "하루가 다르게 배가 불러오고 몸의 중심이 변하는 아내에게, 별거 아닌것 같아 보이는 사소한 일들도 도움이 필요해요.\n\n장바구니를 옮기는 일, 신발끈을 묶는 일, 바닥에 떨어진 동전을 줍는 일...\n\n이런 사소한 일 하나하나에 도움이 필요한 아내가 미안함을 느끼지 않도록 곁에서 면밀히 살피며 도움을 요청하기전에 먼저 손을 내미는 남편이 되어보세요!",
          },
          {
            subTitle: "익숙하게 누리던 것들을 놓아줄 마음의 준비...",
            discribed:
              "이제는 익숙했던 많은 것들과 누리고 있던 많은 것들을 슬슬 놓아줄 때가 됐어요.\n\n좋아하던 취미, 여가, 음식, 커피...\n\n아기가 태어나면 찾아올 변화들에 대한 마음의 준비를 하며 출산을 기다려요.\n\n누려왔고 익숙했던 지금까지의 삶과는 다른, 새로운 만남으로부터 시작되는 삶이 가져다 줄 행복은 무엇과도 비교할 수 없을거예요!",
          },
        ],
      },
    },
    {
      week: 25,
      baby: {
        head: {
          title: "바깥의 소리에 귀를 기울여요!",
          discribed: "큰 페트병만 한 크기에요!",
          size: "약 34cm (700g)",
        },
        body: [
          {
            subTitle: "폐가 활발하게 성장해요!",
            discribed:
              "태어난 후 아기가 정상적인 폐기능을 할 수 있도록 계면 활성 물질을 계속해서 생산하고 있어요.\n\n폐포도 생성되고 있어요.\n\n아기가 태어나서 울면 활짝 펴지게 될거예요.\n\n그리고 태아의 콧구멍들이 열리기 시작해 이제는 코로도 호흡 운동을 할 수 있게돼요.",
          },
          {
            subTitle: "엄마 아빠의 목소리에 반응해요!",
            discribed:
              "다른 소리보다 엄마와 아빠의 목소리에 가장 큰 반응을 보여요.\n\n태아는 지금 엄마 아빠와 교감을 하고있어요!",
          },
        ],
      },
      mom: {
        head: {
          title: "배가 많이 무거워졌어요!",
          discribed: "자궁의 크기도, 몸무게도, 양수의 양도 빠르게 늘어나요!",
        },
        body: [
          {
            subTitle: "몸무게가 급격히 늘고 배가 많이 불러와요!",
            discribed:
              "배가 많이 불러 호흡이 가빠지고 잠을 자기가 힘들어져요.\n\n태아의 급격한 성장으로 자궁이 위를 압박해 소화가 잘되지 않는 증상이 자주 발생해요.\n\n식사는 조금씩 자주 하고, 자극적인 음식 피하도록 해요.",
          },
          {
            subTitle: "임부복을 준비해요!",
            discribed:
              "몸을 조이고 혈액순환을 방해하는 옷 대신, 신축성이 좋고 계절에 맞게 통풍과 보온이 잘되는 임부복을 준비해요.\n\n브래지어의 경우, 앞쪽에 후크가 있는 수유 브래지어를 구매하면 출산 후 모유 수유를 할때까지 유용하게 사용할 수 있어요.",
          },
          {
            subTitle: "안구 건조증이 심해져요!",
            discribed:
              "이 시기에는 눈이 건조하거나 뻑뻑하고 빛에 예민해지거나 모래가 들어간 것 같은 느낌이 들 수 있어요.\n\n건조함이 심할 경우 식염수나 인공눈물을 넣을 수 있어요.\n\n비타민 A가 풍부한 당근을 간식으로 먹는 것도 좋은 방법이에요.\n\n비타민 A가 풍부한 당근은 태아의 세포 성장과 눈에도 좋답니다.",
          },
          {
            subTitle: "임신선이 생겨요!",
            discribed:
              "배, 엉덩이, 가슴 부분에 흐릿한 붉은 선(임신선)이 생기는 것을 발견할 수 있어요.\n\n임신선은 출산 후 아주 흐리게 되거나 없어지므로 너무 걱정하지 않아도 돼요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아기는 엄마와 아빠의 목소리에 귀를 쫑긋!",
          discribed: "아기에게 더 많은 이야기를 들려주세요!",
        },
        body: [
          {
            subTitle: "태아에게 꾸준히 태담을 들려주세요!",
            discribed:
              "태아에게 엄마 아빠의 사랑을 전하고 아기와 도란도란 이야기를 주고받아 주세요.\n\n일상생활, 자연, 날씨의 변화 등 아이에게 하고 싶은 이야기를 밝고 사랑스러운 목소리로 말해주세요.\n\n매일 뱃속의 아기와 꾸준히 이야기를 나누면서 점차 대화의 양을 늘려가는 것이 중요해요.\n\n대화를 통해 태아와 자주 접촉하면 태아의 좌뇌와 우뇌를 고르게 발달시켜 지적 능력과 정서 발달에 도움이 돼요.\n\n태아에게 엄마의 배 위에서 나직이 들려오는 굵고 편안한 아빠의 음성은 태아가 가장 좋아하는 음악과도 같아요.",
          },
          {
            subTitle: "아기의 이름은 생각해 보셨나요?",
            discribed:
              "아직 출산까지는 어느정도 시간이 남아있지만, 아기의 이름을 미리 생각해 보는건 어떨까요?\n\n이름을 정하는 방법엔 여러가지가 있겠지만, 지금부터 차근차근 생각해봐요.\n\n엄마와 아빠 모두가 만족할 수 있는 멋진 이름을 짓기를!",
          },
        ],
      },
    },
    {
      week: 26,
      baby: {
        head: {
          title: "아기는 엄마의 감정을 공유해요!",
          discribed: "두리안만 한 크기에요!",
          size: "(약 : 35cm, 750g)",
        },
        body: [
          {
            subTitle: "손을 더 정교하게 움직일 수 있어요!",
            discribed:
              "움직임이 더욱 활발해져서 태동도 활발하게 느낄 수가 있고, 손과 발을 쥐고 펴는 동작도 능숙해졌어요.\n\n예전보다 세세한 동작도 할 수 있게 되어 손으로 자신의 몸을 만져보기도 하고 탯줄을 만지면서 놀기도 해요.\n\n태아는 보통 07~10시 사이에 가장 활발한 움직임을 보여요.\n\n이 시간대를 노리면 태동을 기록하는데 도움이 돼요.",
          },
          {
            subTitle: "엄마와 감정을 함께 해요!",
            discribed:
              "이제 태아는 엄마의 감정을 함께 느껴요.\n\n엄마가 우울하면 태아도 울적해지고, 엄마가 기분이 좋고 즐거우면 태아도 덩달아 즐거워한답니다!",
          },
        ],
      },
      mom: {
        head: {
          title: "배가 많이 나와 움직임이 불편해요!",
          discribed: "몸의 줌심을 잡기 어려워 일상생활에 불편함이 생겨요.",
        },
        body: [
          {
            subTitle: "갈비뼈에 통증이 느껴져요!",
            discribed:
              "태아가 성장하면서 자궁이 점차 커지게 되는데, 올라온 자궁의 압박을 이기지 못해 맨 아래쪽 갈비뼈가 바깥쪽으로 휘어져 통증이 생겨요.\n\n자궁은 위장도 압박해 소화가 잘 안 되고 속이 쓰리는 증상이 지속돼요.\n\n자궁 근육이 확장되면서 아랫배가 따끔거리는 통증이 생기기도 해요.",
          },
          {
            subTitle: "몸의 중심이 앞으로 쏠려요!",
            discribed:
              "배가 커지면서 등과 허리를 곧게 펴고 서면 몸의 중심이 앞으로 쏠리고, 임신부는 체중을 지탱하기 위해 상체를 뒤로 젖히게 돼요.\n\n이때 임신부의 체중과 등과 허리 근육의 무게가 허리에 더해져 요통을 유발해요.\n\n항상 바른 자세를 하고, 평소 산책이나 요통 방지 체조로 몸을 틈틈이 몸을 이완시켜주는 것이 좋아요.\n\n배가 꽤 나와있기 때문에 바닥이나 발 아래 계단이 잘 안 보일 수도 있어요.\n\n계단을 오르내릴때는 난간을 잡고 한발 한발 천천히! 조심해야해요.",
          },
          {
            subTitle: "때때로 악몽을 꿔요!",
            discribed:
              "임신이 진행되면서 많은 임산부들이 무서운 꿈을 꾸거나 가위에 눌리기도 해요.\n\n임산부가 무의식적으로 임신에 대한 불안, 엄마가 된다는 사실에 대한 두려움을 느끼기 때문이에요.\n\n어디론가 이리저리 뛰어다닌다거나 아주 높은 곳에서 떨어지는 꿈을 꾸기도 하는데, 크게 걱정할 필요는 없어요.\n\n마음을 안정시키고 긍정적인 생각을 많이 하도록 노력하는 것이 좋아요.\n\n엄마가 웃으면 아기도 웃어요!\n\n엄마가 느끼는 감정을 아기도 똑같이 느끼고 있답니다.\n\n그냥 한번 웃어보세요!",
          },
        ],
      },
      dad: {
        head: {
          title: "이제 100일도 남지 않았어요!",
          discribed: "미리미리 출산에 대비하세요!",
        },
        body: [
          {
            subTitle: "아빠도 출산에 대비해요!",
            discribed:
              "아직은 여유가 있다고 생각할 수 있지만, 시간은 정말 빠르게 흐른답니다.\n\n출산의 순간이 다가왔을 때를 대비해 아빠도 미리 준비해요!\n\n출산을 하기로 결정한 병원까지 가는 길을 파악해두세요.\n\n차를 타고 갈지, 택시를 이용할지, 어느 길로 가야하고 어느 시간대에 막히는지를 미리 확인해두면 좋아요.\n\n진통이 찾아왔을때, 가진통과 진진통을 구분할 수 있다면 더 좋아요.\n\n가진통의 경우, 자궁수축이 불규칙하고 예측할 수 없으며 움직이거나 자세를 바꾸면 멈추기도 해요.\n\n반면 진진통은 규칙적인 패턴이 있고 시간이 지날수록 더 강하고 짧은 간격으로 찾아와요.\n\n진통을 직접 겪는 아내는 진통의 간격을 파악하기가 어렵답니다.\n\n이럴때 남편이 침착하게 시간을 재 준다면 정말 큰 도움이 된답니다.",
          },
        ],
      },
    },
    {
      week: 27,
      baby: {
        head: {
          title: "눈꺼풀이 완성되고, 눈동자가 만들어져요!",
          discribed: "폭신한 곰인형만 한 크기에요!",
          size: "약 37cm, 900g",
        },
        body: [
          {
            subTitle: "계속 양수를 마셔요!",
            discribed:
              "양수를 마시며 횡격막 운동도 하는데, 태어나서 폐를 확장시키기 위한 연습이에요.\n\n태아의 폐 속에서 폐포가 발달하기 시작하고, 폐포는 아기가 태어나서 여덟 살이 될 때까지 계속 증가해요.\n\n폐포 주위엔 태아에게 필요한 산소를 흡수하고 이산화탄소를 방출할 혈관이 기하급수적으로 늘어나요.\n\n콧구멍도 열려서 태아는 이제 스스로 자신의 근육을 사용해 숨쉬는 흉내를 내기 시작해요.",
          },
          {
            subTitle: "눈을 뜰 수 있어요!",
            discribed:
              "눈꺼풀이 나누어지면서 이제 눈을 깜빡일 수 있어요!\n\n눈을 떠 앞을 보거나 초범을 맞추기도 해요.\n\n눈동자는 아직 맑고 투명한 상태.\n\n동공은 출생 후 몇달이 지나야 본래의 색을 띄게 돼요.",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 중기가 끝나가요!",
          discribed: "임신 20주 이후에 나타나는 임신중독증을 주의하세요!",
        },
        body: [
          {
            subTitle: "다리가 붓고 저려요!",
            discribed:
              "다리가 붓고 쉽게 피로해지며 쥐가 나기도 하는데, 밤에 잠을 잘 때 더 심해지기도 해요.\n\n이 때 종아리 부분을 꾹꾹 눌러주며 마사지를 해주면 증상이 완화될 수 있어요.\n\n이 시기에는 정상적으로 혈압이 조금 높아질 수 있습지만 체중이 갑자기 급격하게 늘고, 손과 발이 붓는다면 임신 중독증일 수 있으므로 담당의와 상담을 해야해요.",
          },
          {
            subTitle: "임신중독증 조심!",
            discribed:
              "흔히 임신중독증이라 불리는 전자간증은 임신과 합병된 고혈압성 질환을 뜻해요.\n\n고혈압과 함께 소변에서 단백성분이 나오는 경우를 전자간증으로 분류해요.\n\n전자간증은 산모는 물론 태아에게까지 영향을 주며, 중증으로 진행 시 사망까지도 이르게 할 수도 있어요.\n\n현재까지 밝혀진 바로는,임신 초기 태반으로의 혈류공급에 장애가 생기는 것을 일차적인 원인으로 보고 있어요.\n\n전자간증의 증상으로는 지속되는 심한 두통, 급격한 체중증가, 갑작스러운 시야 흐림, 상복부 통증, 부종 등이 있어요.\n\n전자간증은 아주 위험한 질환이며, 유일한 완치 방법은 출산이에요.\n\n위와 같은 증상이 있다면 반드시 병원에서 검사를 받아야 해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "육체적, 정신적으로 힘든 아내가 기댈곳은 바로 남편!",
          discribed: "고생하는 아내에게는 남편의 도움이 절실해요.",
        },
        body: [
          {
            subTitle: "달라진 모습에 힘들어하는 아내에게..",
            discribed:
              "임신 전과는 확연하게 달라진 모습에 아내가 많이 힘들어하고 있어요.\n\n배가 정말 많이 불러오고, 임신선이 생기기도 하며 가슴의 모양도 이전과는 달라졌어요.\n\n누구보다 가장 당황스러운 사람은 아내 자신일거예요.\n\n보이는 대로 지적하지 말고 따뜻한 말로 아내를 안심시켜 주세요.",
          },
          {
            subTitle: "틈틈히 다리 마사지를 해주세요!",
            discribed:
              "하지의 혈액순환이 원활하지 못해 아내의 다리는 쉽게 붓고 피로해져요.\n\n잠을 자야하는 밤에 그 증상이 더 심해지고, 쥐가 나기도 해요.\n\n이럴때 종아리 마사지를 해주면 증상 완화에 도움이 돼요.\n\n배가 많이 부른 아내를 대신해 로션이나 오일을 발라 부어있는 아내의 종아리에 마사지를 해주세요!",
          },
        ],
      },
    },
    {
      week: 28,
      baby: {
        head: {
          title: "머리가 자라는동안 뇌도 자랐어요!",
          discribed: "긴 장화만 한 크기에요!",
          size: "약 38cm (1kg)",
        },
        body: [
          {
            subTitle: "뇌가 커지고, 뇌 조직이 발달해요!",
            discribed:
              "임신 후기에 접어들면서 태아는 크게 자라 자궁 내에서 많은 자리를 차지하게 돼요.\n\n이 시기의 가장 큰 특징은 뇌 조직이 크게 발달한다는 거예요.\n\n태아의 뇌가 훨씬 커지고, 뇌 조직의 수도 증가하며, 뇌 특유의 주름과 홈이 만들어져요.\n\n또 뇌세포와 신경순환계가 완벽하게 연결되어 활동하기 시작해요.\n\n이 시기에는 다양한 방법으로 태아의 뇌를 자극해주는게 좋답니다!",
          },
          {
            subTitle: "규칙적인 생활 리듬을 가져요!",
            discribed:
              "28주가 되면 태아는 규칙적으로 움직여요.\n\n규칙적으로 자고 일어나며, 잠을 자면서 꿈을 꾸기도 해요.",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 말기에 접어들었어요!",
          discribed: "아기가 태어날 때를 대비해 여러 계획을 세워보아요!",
        },
        body: [
          {
            subTitle: "유방에서 초유가 만들어져요!",
            discribed:
              "임신 후기에 들어서면서부터 유방에서는 초유가 만들어져요.\n\n초유에는 면역 성분이 들어있고 각종 영양소가 풍부하기 때문에 신생아에게 꼭 먹이는 것이 좋아요.\n\n초유는 노르스름한 색을 띄는 진한 액체예요.\n\n빠르면 지금부터 가슴에서 초유가 흘러나올 수 있으니 가슴패드를 준비해두도록 해요.",
          },
          {
            subTitle: "자꾸 깜빡해요!",
            discribed:
              "많은 임산부들이 경험한다고 말하는 임신 중 건망증은 아직 원인이 정확하게 밝혀지지 않았어요.\n\n중요한 건 이러한 건망증 증상을 겪는 엄마들이 많다는 거예요!\n\n지극히 자연스러운 현상이니 너무 스트레스를 받지 않도록 해요.\n\n메모하는 습관을 들이고, 모든걸 혼자 해결하려 하지 않아도 된답니다.\n\n가장 든든한 가족, 남편이 있잖아요!",
          },
          {
            subTitle: "좌골신경통이란?",
            discribed:
              "허리에서부터 엉덩이까지 나타나는 통증인 좌골신경통은 주로 임신 6개월 이후부터 나타나요.\n\n증상이 심해질 경우 다리를 따라 발뒤꿈치와 무릎까지도 심한 통증이 생길 수 있어요.\n\n임신중 임신 중에 좌골신경통이 생기는근본적인 이유는 자궁 내에서 태아가 자라면서 척추 아래의 좌골신경을 누르는 것 때문이에요.\n\n또한 산모는 균형을 유지하기 위해서 골반을 앞으로 미는 경향이 있는데, 이렇게 되면 무게 중심이 변해 등이 뒤로 쏠려 좌골신경에 압박을 가하게 돼요.\n\n좌골신경통은 온열 찜질이나 따뜻한 목욕, 스트레칭을 통해 증상을 완화시킬 수 있어요.\n\n체중을 분산해주는 골반 벨트를 착용하는 것은 바른 자세를 유지하는데 도움이 돼요.\n\n하지만 통증이 너무 심하다면 병원을 방문하여 적절한 치료를 받기를 권장합니다.",
          },
          {
            subTitle: "혹시... Rh-?",
            discribed:
              "혹시 혈액형이 Rh-이고 남편은 Rh+인 엄마 계신가요?\n\nRhoGAM(로감)주사에 대해 알고 계세요?\n\n로감주사는 혈관에 유입된 태아의 혈액이 항원항체 반응을 일으키지 못하도록 차단하는 역할을 하는 주사예요.\n\n28주는 로감주사를 맞아야 하는 시기랍니다.\n\n혹시 아직 이야기를 듣지 못했다면 다음 검진때 물어보세요!",
          },
        ],
      },
      dad: {
        head: {
          title: "아내의 뒤를 든든히 받쳐주는 남편!",
          discribed:
            "혹시 아내가 무언가 실수를 하더라도 괜찮아요, 남편이 있으니까요!",
        },
        body: [
          {
            subTitle: "자꾸만 깜빡하는 아내를 위하여!",
            discribed:
              "요즘들어 자꾸만 깜빡깜빡 하는 아내.\n\n갑작스레 도진 건망증에 업무나 일상생활에 문제가 생기곤 해요.\n\n그런 아내를 도와주세요.\n\n아내가 뭔가를 잊었을 떄 화를 낸다거나 큰소리로 지적해서는 안돼요!\n\n항상 아내의 주변을 살피고, 아내가 뭘 찾고 있는지 유심히 지켜봐요.",
          },
          {
            subTitle: "남는건 사진 뿐!",
            discribed:
              "아내의 배가 하루가 다르게 커지고 있어요.\n\n이렇게 배가 커진 지금, 만삭 촬영을 하는건 어떤가요?\n\n만삭 촬영은 만삭에 해야 맞겟지만, 대개 배가 너무 크지 않고 가장 예쁜 28주에서 32주 사이에 가장 많이 찍는답니다.\n\n물론 정해진 시기가 있는건 아니니 언제 찍을지는 엄마와 아빠가 상의해서 정해보세요!",
          },
        ],
      },
    },
    {
      week: 29,
      baby: {
        head: {
          title: "지방이 쌓이면서 피부가 점점 보들보들해져요!",
          discribed: "토끼만 한 크기에요!",
          size: "약 39cm (1.2~1.3kg)",
        },
        body: [
          {
            subTitle: "자궁 밖의 빛을 감지해요!",
            discribed:
              "임신29주가 되면 태아는 완전히 눈을 뜨고 자궁 밖의 밝은 빛을 볼 수 있기 때문에, 빛을 비추면 빛을 따라 고개를 돌려요.\n\n또, 눈꺼풀과 눈동자가 완성되어 앞을 보고 초점을 맞추는 연습을 시작해요.",
          },
          {
            subTitle: "지방을 쌓고 있어요!",
            discribed:
              "온몸을 감싸고 있던 배내털은 점점 줄어들어 어깨와 등 쪽에 드문드문 남고, 지방층이 생기면서 쪼글쪼글했던 몸이 오동통하게 살이 올라요.",
          },
        ],
      },
      mom: {
        head: {
          title: "엄마의 몸은 서서히 아기를 낳을 준비를 해요!",
          discribed: "이제부터는 검진 횟수도 늘어나요!",
        },
        body: [
          {
            subTitle: "이제부터는 2주에 한번씩 검진을 받아요!",
            discribed:
              "엄마의 건강상 큰 문제가 없고 태아도 정상적으로 자라고 있다면, 임신29주부터는 2주일에 한 번 정기검진을 받으러 가게 돼요.\n\n임신 8~9개월까지는 이렇게 2주일에 한 번씩 정기검진을 받다가 마지막 달에는 1주일에 한 번씩 정기검진을 받게 된답니다.\n\n정기검진을 받을 때는 평소의 이상 증세에 대해 자세히 물어보고, 출산에 대한 정보도 충분히 얻는 것이 좋아요.",
          },
          {
            subTitle: "자궁 수축이 일어나요!",
            discribed:
              "하루에도 몇 번씩 자궁이 딱딱하게 뭉치면서 수축되는 것을 느껴요.\n\n대개 하루에 4~5회 정도 주기적으로 자궁 수축이 일어나는데, 이 때는 잠시 쉬는 것이 좋아요.\n\n하지만 수축이 자주 일어나면 조산의 위험이 있으므로 병원에 가서 진찰을 받도록 해요.",
          },
          {
            subTitle: "태동으로 갈비뼈 부위에 통증을 느껴요!",
            discribed:
              "임신 후기에 접어들면 태동이 점점 강해져, 태아의 발길질에 깜짝깜짝 놀라거나 통증을 느끼기도 해요.\n\n특히 태아가 제자리를 잡기 시작하면 머리가 아래에, 발이 위로 놓이는데 이때 발길질을 하면 임신부의 갈비뼈를 차게 되므로 가슴 부분에 통증을 느끼게 돼요.",
          },
          {
            subTitle: "분비물이 많아져 외음부가 가려워요!",
            discribed:
              "이제 모체는 서서히 출산 준비에 돌입해요.\n\n우선 원활한 출산을 위해 자궁 경부에서 배출되는 분비물이 늘어나요.\n\n이로 인해 외음부에 접촉성 피부염이나 습진이 생겨 가려움증이 생길 수 있어요.\n\n가려움증을 예방하기 위해 속옷을 자주 갈아입고 몸을 항상 청결하게 유지하는 것이 중요하답니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "예비아빠로서 아기를 만날 준비를 해요!",
          discribed: "출산준비를 시작해볼 때예요!",
        },
        body: [
          {
            subTitle: "아빠가 될 본격적인 준비를 해볼까요?",
            discribed:
              "예비 아빠들이 함께하는 출산교실에 참여해보세요!\n\n주변의 보건소나 산부인과에서 운영하는 출산교실 프로그램을 찾아보세요.\n\n참여할 수 있는 프로그램의 명단을 정리 한 뒤 엄마와 함께 상의해보도록 해요.",
          },
          {
            subTitle: "정기검진은 엄마 아빠가 함께!",
            discribed:
              "임신 후기에 접어들며 정기검지의 간격이 짧아지고 있어요.\n\n매번 동행한다는 것이 아빠에게 쉬운 일은 아니라는걸 알지만, 아빠가 함께한다면 아내는 더 편안한 마음으로 검사를 받을 수 있어요.\n\n또, 담당 의사선생님을 만나 궁금했던 것들을 물어보고 자세한 설명도 들을 수 있으니 아빠에게도 좋은 기회가 될거예요.",
          },
        ],
      },
    },
    {
      week: 30,
      baby: {
        head: {
          title: "아기는 태어나기위해 열심히 준비중!",
          discribed: "큰 무우만 한 크기에요!",
          size: "약 40cm (1.4~1.5kg)",
        },
        body: [
          {
            subTitle: "태어날 자세를 준비해요!",
            discribed:
              "태아의 뇌가 빠르게 자라고 있으며 태아의 위치가 점차 아래로 내려와요.\n\n이때쯤 태아는 머리를 아래로 향하며 태어날 자세를 준비하는데, 가끔 머리를 똑바로 세우고 있는 태아들도 있어요.\n\n아직은 시간이 있으니 너무 걱정하지 않아도 돼요!",
          },
          {
            subTitle: "열심히 연습중!",
            discribed:
              "뱃속 태아는 출산 후 호흡을 위하여 꾸준히 호흡 연습을 하고 있어요.\n\n아직 호흡히 완전하지는 않지만 폐 발달이 거의 완료되었어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "자궁이 많이 커져 이제는 배꼽과 명치 사이까지 올라왔어요!",
          discribed: "위와 심장도 압박을 받아 가슴이 갑갑하고 속도 쓰려요.",
        },
        body: [
          {
            subTitle: "가슴이 갑갑하고 위가 쓰려요!",
            discribed:
              "자궁이 점점 커지면서 횡격막을 압박하기 때문에 숨쉬기가 곤란해지기도 해요.\n\n심장이 눌리면서 가슴에 답답함을 느끼거나 소화불량이 올 수 있기 때문에 너무 늦은 시간에 먹는 야식은 피하는 것이 좋아요.\n\n태아의 머리가 아래를 향하면서 방광을 압박하기 때문에 겨우 없어진 줄 알았던 빈뇨 증상이 다시 나타나게 돼요.\n\n조금만 더 힘내세요!",
          },
          {
            subTitle: "가벼운 운동은 추천합니다!",
            discribed:
              "지금 엄마는 너무 무리해서는 안되지만 가벼운 운동은 엄마의 건강에 도움이 돼요.\n\n식후 혈당을 낮출 수 있는 가벼운 걷기나근력 향상에 도움을 주는 임산부 요가와 같은 운동도 추천드려요.",
          },
          {
            subTitle: "본격적인 출산준비를 해요.",
            discribed:
              "아직 시간이 조금 남아있지만, 출산 예정일은 언제든지 변할 수 있고 누구나 조산의 위험이 있기 때문에 미리 준비해두는게 좋아요.\n\n분만 방법을 정하고 입원과 분만의 절차를 확인한 뒤 산후조리 계획을 세워요.\n\n출산 전 후 필요한 용품들에 대한 무매 계획을 세워요.",
          },
        ],
      },
      dad: {
        head: {
          title: "출산준비도 엄마와 아빠가 함께!",
          discribed: "서로 역할을 나누어 준비해보아요.",
        },
        body: [
          {
            subTitle: "서류작업은 내게 맡겨!",
            discribed:
              "출산을 얼마 남기지 않은 지금 이시점, 임신과 출산은 생각보다 많은 서류작업을 필요로 해요.\n\n정신없는 엄마 대신 아빠가 맡아 담당해주세요.\n\n각종 출산 지원 제도나 복지 제도에 대해 알아보고 꼼꼼하게 처리해주세요.\n\n출산의 과정에 필요한 예산을 항목별로 나누어 미리 계산해 보는 것도 좋은 방법이에요.",
          },
        ],
      },
    },
    {
      week: 31,
      baby: {
        head: {
          title: "아기가 세상 밖으로 나올 날이 머지않았어요!",
          discribed: "족제비만 한 크기에요!",
          size: "약 41~42cm (1.7kg)",
        },
        body: [
          {
            subTitle: "오감이 모두 발달해요!",
            discribed:
              "임신 31주가 되면 태아는 두 눈을 뜨고 감는 연습을 하며 어느 정도 어둠과 밝음을 구별할 줄 알아요.\n\n두 눈이 완성되어 동공을 수축하고 이완할 수 있어요.\n\n하지만 시력은 성인처럼 멀리 볼 수 있을 정도는 아니고 시야는 20~30㎝정도예요.\n\n배 위에 불빛을 비추면 고개를 돌리거나 만지기 위해 손을 내밀기도 한답니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "빠르게 늘어나는 체중으로 여러가지 불편함이 생겨요!",
          discribed:
            "배가 점점 더 불러오고, 커진 자궁이 신체기관들을 압박해요.",
        },
        body: [
          {
            subTitle: "요통과 어깨 결림이 생겨요!",
            discribed:
              "임신 후기에는 허리를 지탱하는 인대와 근육이 이완되고 느슨해지면서 다시 요통을 느끼게 돼요.\n\n또, 무거워진 배를 지탱하기 위해 뒤로 젖혀진 어깨에 피로가 쌓여 통증을 느끼게 되지요.\n\n특히 어깨 근육은 커진 유방도 지탱해야 하기 때문에 출산이 가까워질수록 통증은 점점 더 심해져요.\n\n통증을 완화하기 위해서는 임산부 체조나 수영과 같은 적절한 운동으로 혈액 흐름을 좋게 하고, 어깨를 마사지해주는 것이 좋아요.",
          },
          {
            subTitle: "호르몬 영향으로 출혈이 생겨요!",
            discribed:
              "이 시기에는 몸속 혈액이 자궁을 중심으로 회전하게 돼요.\n\n호르몬의 영향으로 잇몸에서 피가 나거나 치질이 생기기도 하며, 정맥이 비정상적으로 늘어나 정맥류가 생기기도 해요.",
          },
          {
            subTitle: "요실금 증상이 나타나요!",
            discribed:
              "재채기를 하거나 큰소리로 웃을 때 자신도 모르게 소변이 새어 나오는 경우가 있어요.\n\n이는 커진 자궁이 방광을 압박해서 생기는 현상으로 임신부에게 흔히 나타나는 증세이므로 걱정하지 않아도 돼요.\n\n흔히 배가 점점 커지는 임신 30주 이후에 많이 나타나며, 출산후에는 자연스레 사라져요.",
          },
          {
            subTitle: "몸무게 빠르게 늘어요!",
            discribed:
              "몸무게가 정말 빠르게 증가해요!\n\n아기의 몸무게가 합쳐졌기 때문이에요.\n\n임신초에 비해 몸무게가 많이 늘었기 때문에 허리에 무리가 가지 않도록 동작에 주의를 기울여 주세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "본격적으로 출산 이후를 준비해봐요!",
          discribed: "미리미리 준비해야 늦지 않아요!",
        },
        body: [
          {
            subTitle: "산후조리 방법을 선택해요!",
            discribed:
              "산후조리 방법에는 여러가지가 있고 각자 장단점이 있어요.\n\n아내와 함께 상의하여 가장 잘 맞는 산후조리 방법을 선택해요.",
          },
          {
            subTitle: "아기방을 꾸며보는건 어때요?",
            discribed:
              "아직 출산까지는 어느정도 시간이 남았지만, 차곡차곡 모아온 아기용품들과 함께 아기 방을 꾸며보세요!\n\n아기를 위한 가구를 마련해 배치해보세요.\n\n아기를 맞이할 준비를 시작해보는거예요.",
          },
        ],
      },
    },
    {
      week: 32,
      baby: {
        head: {
          title: "피부가 본연의 색을 띠기 시작해요!",
          discribed: "책가방만 한 크기에요!",
          size: "약 42~43cm (1.8kg)",
        },
        body: [
          {
            subTitle: "태동 검사를 받아봐요!",
            discribed: "태동검사를 통해 태아의 심장 박동을 확인할 수 있어요!",
          },
          {
            subTitle: "피부와 손발톱이 핑크빛이에요!",
            discribed:
              "붉은색이었던 피부 아래 지방이 늘어나 도톰해지면서 연한 핑크빛이 되었어요.\n\n손톱과 발톱도 거의 끝까지 자랐어요.\n\n머리 크기와 비교해 봤을 때 팔다리의 비율이 적절해 신생아의 모습을 거의 갖추었어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 9개월차에 접어들며, 여러모로 몸이 많이 힘들어요!",
          discribed:
            "이럴때일수록 기운을 내고 충분한 영양섭취를 해주어야 해요!",
        },
        body: [
          {
            subTitle: "엄마의 관절이 늘어나 뚝뚝!",
            discribed:
              "호르몬의 영향으로 엄마의 관절이 늘어나 약해져 있어요.\n\n엄마가 몸을 움직일때마다 관절이 어긋나 뚝뚝 소리가 나요.\n\n임신의 자연스러운 현상 중 하나로, 자연스럽게 사라지니 너무 걱정할 필요 없어요.",
          },
          {
            subTitle: "배가 많이 불러 행동에 제약이 생겨요.",
            discribed:
              "이리저리 배를 부딪히고, 배에 음식을 흘리기 쉽고, 중심을 잡기 어려워지며, 설거지가 힘들어요.\n\n신체적 변화에 따라오는 자연스러운 현상이에요.\n\n너무 속상해하지 말고 자연스럽게 받아들이려고 노력해요.",
          },
          {
            subTitle: "수분섭취 영양섭취!",
            discribed:
              "지금 엄마의 배 속에는 아기가 있어, 엄마는 두 명 분의 양을 먹어야해요.\n\n충분한 영양소를 골고루 섭취하는 것은 물론,몸속의 노폐물을 잘 걸러 배출하기 위해 수분섭취를 제대로 하는 것도 중요해요.",
          },
          {
            subTitle: "역아 바로 세우는 체조!",
            discribed:
              "배 속의 아이가 거꾸로 있는 상태라도 아직 태아의 자세를 바꿀 시간은 충분해요!\n\n임신 8개월부터 꾸준히 역아 바로 세우는 체조를 해준다면 막달에는 제 위치를 찾을 수 있어요.",
          },
          {
            subTitle: "모유수유 준비!",
            discribed:
              "태아에게 모유 수유가 좋다는 사실은 너무 잘 알지만, 누구나 모유 수유가 가능한 건 아니에요.\n\n모유 수유를 위해서는 몇가지 준비가 필요해요.\n\n먼저, 유두를 청결하게 관리해주세요.\n\n그리고 수유를 위한 유두의 모양을 확인해주세요.\n\n만약 본인의 유두가 함몰유두라면 교정기를 통해 충분히 돌출시켜주세요.\n\n또, 모유 수유를 돕는 다양한 용품들을 미리 구비해두는 것이 좋아요.\n\n유축기, 수유용 브래지어, 유두 진정 팩 까지 다양한 물품들이 있답니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠의 몸도 출산 이후를 준비해야해요!",
          discribed: "아빠의 건강도 각별히 신경써주세요!",
        },
        body: [
          {
            subTitle: "임신과 출산은 체력싸움!",
            discribed:
              "이제 벌써 임신 9개월차에 접어드는 주차예요.\n\n40주를 다 채우지 않아도 37주부터는 정상출산으로 보고있기때문에 이제 출산은 앞으로 약 한달정도가 남았어요.\n\n임신과 출산은 체력싸움!\n\n아빠의 건강도 신경써주세요.\n\n건강은 어느순간 갑자기 주어지는게 아니라 에너지가 한계에 달하지 않도록 꾸준히 관리해줘야 해요.\n\n영양제도 챙겨먹고 적당한 운동을 하며 체력을 길러요.\n\n이제 정말 얼마 남지 않았어요!",
          },
          {
            subTitle: "모유수유를 위해 아빠도 공부해야 해요!",
            discribed:
              "성공적인 모유 수유를 위해서는 아빠의 참여도 중요해요.\n\n모유 수유 과정에 아빠가 저극적으로 참여해야해요.\n\n수유를 위한 공간을 미리 준비해주세요.\n\n모유 수유를 진행하게 되면 대략 2~30분간은 가만히 앉아 수유를 해야하니수유가 끝나면 피곤한 엄마 대신 아빠가 아기를 케어해 주세요.\n\n미리 유축해둔 모유를 사용해 야간 수유를 도와줄 수도 있어요.\n\n젖몸살을 완화시키는 마사지를 미리 익혀두면 큰 도움이 된답니다.",
          },
        ],
      },
    },
    {
      week: 33,
      baby: {
        head: {
          title: "생존을 위한 기본기능을 웬만큼 다 갖추었어요!",
          discribed: "쿼카만 한 크기에요!",
          size: "약 44cm (2kg)",
        },
        body: [
          {
            subTitle: "호흡 연습을 계속해요!",
            discribed:
              "태아는 폐를 제외한 나머지 부분의 발육이 거의 마무리되었고 폐 운동을 위해 양수를 들이마심으로써 호흡 연습을 계속하고 있어요.\n\n태아는 매일 방광에서 0.5l 정도의 소변을 배출하므로, 양수는 태아의 소변으로 많이 채워지게 돼요.",
          },
          {
            subTitle: "성기가 모두 발달됐어요!",
            discribed:
              "남자 아이의 경우 태아의 고환이 복부로부터 음낭 속으로 내려오게 돼요.\n\n때에 따라 고환 1개 또는 2개 모두 생후까지 제자리로 이동하지 못하는 경우도 있어요.\n\n하지만 고환이 제자리로 오지 못했다고 해서 크게 걱정하지 않아도 돼요.\n\n위치를 잡지 못한 고환은 대개 첫돌 때까지 제자리를 찾아가기 때문이에요.\n\n여자아이의 경우에는 대음순이 발달했어요.\n\n지금은 남자아이와 여자아이 모두 성 호르몬이 활발하게 분비되고 있어 출산시 아기의 성기가 부어보여요.",
          },
        ],
      },
      mom: {
        head: {
          title: "자궁크기가 원래보다 열다섯배쯤 커졌어요!",
          discribed: "늘어난 자궁때문에 몸이 힘들어요.",
        },
        body: [
          {
            subTitle: "소변이 잦아지고 요실금 증상이 나타나요",
            discribed:
              "배꼽이 튀어나올 정도로 배가 불룩해지고 단단해졌어요.\n\n소변을 보는 횟수가 늘어나고, 소변을 본 후에도 방광에 오줌이 남아 있는 것 같은 기분이 들기도 해요.\n\n또 재채기나 기침을 하면 소변이 조금 흘러나오기도 하는데, 이 모든 것이 자연스런 현상이며 출산 후에는 자연스럽게 없어지므로 크게 걱정하지 않아도 돼요.",
          },
          {
            subTitle: "잠들기 어려워요",
            discribed:
              "임신 초기의 증상들과 부른 배 때문에 잠들기 힘들어요.\n\n후기로 갈수록 배가 점점 더 불러오고 화장실도 자주 가고 싶어지며 활발한 태동때문에 숙면을 취하기가 점점 어려워져요.\n\n잠자리에 들기 전에 가볍게 샤워를 하거나 똑바로 눕는 것보다는 옆으로 누워 한쪽 다리를 구부리고 다리 사이에 베개를 넣는 '심스 체위'를 취하는 것이 도움이 될 수 있어요.\n\n무엇보다 규칙적 생활패턴을 유지하려고 노력하는 것이 중요해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아내의 식사에 신경써주세요!",
          discribed: "영양분을 골고루 섭취하는것이 중요해요!",
        },
        body: [
          {
            subTitle: "아내의 영양분 섭취를 신경써주세요!",
            discribed:
              "아기가 무럭무럭 자라나고 있어 충분한 영양소가 필요해요.\n\n세끼 식사만으로는 모든 영양소를 골고루 충족시키기 어려울 수 있어요.\n\n아내와 아기의 건강을 위하여 건강한 간식과 영양제를 챙겨주세요!",
          },
        ],
      },
    },
    {
      week: 34,
      baby: {
        head: {
          title: "세상 밖으로 나올 준비를 해요!",
          discribed: "수박만 한 크기에요!",
          size: "약 45cm (2.1kg)",
        },
        body: [
          {
            subTitle: "머리가 자궁쪽을 향해요!",
            discribed:
              "태아의 두개골은 아직 유연하고 완전히 결합되지 않은 상태예요.\n\n덕분에 분만시 산도를 빠져나오기 수월해요.\n\n태아는 몸을 계속 움직여 위치를 바꾸지만 대부분 머리를 자궁 아래쪽으로 향하고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "출산준비로 바쁘다 바빠!",
          discribed: "이제 정말 출산이 머지않았어요!",
        },
        body: [
          {
            subTitle: "다리에 쥐가 나거나 통증이 느껴져요!",
            discribed:
              "커다란 배를 지탱하려면 다리에 부담이 가 쥐가 나거나 통증을 느낄 때가 많아요.\n\n이럴 때는 무리하지 말고 누워서 다리를 조금 높이 올리고 쉬는 것이 좋다.\n\n직장에 다니는 임신부의 경우 서 있는 시간이 길거나 무리했을 때 아랫배가 당기고 사타구니에 통증이 오기도 하니 적절히 휴식을 취해주는 것이 좋아요.",
          },
          {
            subTitle: "출산을 준비해요!",
            discribed:
              "미리 출산 가방을 준비해요.\n\n필요한 물건들의 리스트를 적고 미리 가방을 싸주는게 좋아요.\n\n산모 준비물 : 산모수첩, 생리대, 산모패드, 수유브라/수유나시, 모유수유용품, 임부팬티, 세면도구,끝이 꺾이는 빨대, 양말, 내의, 물티슈, 복대, 머리끈, 손목보호대, 담요, 회음부 방석 등\n\n아기 준비물 : 가제손수건, 겉싸개, 속싸개, 배냇저고리, 기저귀, 아기비누, 아기로션, 손/발 싸개 등이제부터는 언제 출산해도 이상하지 않으니 마음의 준비를 하고 있어야 해요.\n\n호흡법을 미리 연습해두면 좋아요.\n\n진통이 시작되면 너무 아파서 호흡을 신경 쓸 겨를이 없을지도 모르니,의식하지 않아도 자연스럽게 흘러나올만큼 반복해서 연습하세요!",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠도 출산준비, 바쁘다 바빠!",
          discribed: "코앞으로 다가온 출산, 아빠도 함께 준비해요!",
        },
        body: [
          {
            subTitle: "만삭의 아내를 위하여",
            discribed:
              "커지는 자궁으로 속쓰림과 울렁거림이 심해진 아내를 위해 조금씩 자주 식사를 준비해주세요.\n\n배 주변 피부가 가렵고 따가울 수 있어요.\n\n오일과 크림으로 보습해 주며 마사지를 해주세요.\n\n엄마와 태아 체중이 불어나기 좋은 시기이므로, 식이조절에 신경쓰도록 해요.",
          },
          {
            subTitle: "아빠도 출산가방 준비",
            discribed:
              "출산가방에는 아빠의 물건도 필요해요.\n\n일단 진통이 시작되면 정신이 없어 짐을 챙길 겨를이 없으니 미리미리 챙겨두는게 좋아요.\n\n세면도구, 여벌 옷, 슬리퍼, 휴대폰 충전기 등준비해둔 출산가방은 발견하기 쉬운곳에 둬요.\n\n차로 이동할 예정이라면 가방을 미리 차에 실어놓는것도 좋은 방법이에요.",
          },
        ],
      },
    },
    {
      week: 35,
      baby: {
        head: {
          title: "이제는 자궁속에 남아있는 공간이 거의 없어요!",
          discribed: "아기 크기 : 옷걸이만 한 크기에요!",
          size: "약 47cm (2.4~2.5kg)",
        },
        body: [
          {
            subTitle: "거의 완전한 신생아!",
            discribed:
              "신생아와 거의 비슷한 모습이에요.\n\n지금 세상에 나온다고 해도 99%의 아기가 살아갈 수 있을 정도로 폐를 제외한 내장 기능 대부분이 성숙한 상태예요.\n\n호흡에 문제만 없다면 바로 출산이 가능하답니다.\n\n성기도 거의 완성되며 발톱도 끝까지 다 자랐어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "코앞으로 다가온 출산, 몸도 마음도 준비가 필요해요!",
          discribed:
            "어떤 상황이든 문제없이 대처할 수 있게 미리미리 점검해두어요!",
        },
        body: [
          {
            subTitle: "호흡법을 미리 연습해 볼까요?",
            discribed:
              "분만시 사용될 수 있는 호흡법에는 여러가지 종류가 있어요.\n\n호흡법의 적절한 사용은 산모의 체내에 산소를 공급해서 근육과 조직을 이완시키고, 아기에게도 산소를 공급해요.\n\n미리 본인에게 맞는 호흡법을 확인하고 연습해두어 분만시 자연스럽게 호흡법을 적용할 수 있어야 해요.",
          },
          {
            subTitle: "마음의 준비를 해요!",
            discribed:
              "출산에 대한 두려움은 너무나 자연스러운 마음이에요.\n\n다만, 산전 진찰을 비롯한 산과 의학의 발전을 통해 출산 과정의 위험이나 부담이 이전과는 비교되지 않을만큼 줄었다는 사실을 기억하세요.\n\n불안은 또 다른 불안을 낳아요.\n\n엄마 자기 자신과 아기, 그리고 현대 의학을 믿어보세요!",
          },
        ],
      },
      dad: {
        head: {
          title: "이제부터 눈치게임 시작!",
          discribed: "집중! 이제부터는 언제든지 진통이 시작될 수 있어요.",
        },
        body: [
          {
            subTitle: "언제든 병원으로 갈 수 있는 준비를 해요!",
            discribed:
              "병원으로 가는 경로, 걸리는 시간, 이동 수단 등을 미리 파악해둬야해요.\n\n차에 기름을 여유있게 충전해 두는 것, 잊지마세요!\n\n차에 커다란 수건을 비치해 두면 출산 시 유용하게 쓰일 수 있어요.",
          },
          {
            subTitle: "출산휴가를 사용해요!",
            discribed:
              "배우자 출산휴가란 근로자의 배우자가 출산한 경우 배우자와 태아의 건강보호 등을 위해 신청, 사용하는 휴가를 의미해요.\n\n배우자 출산휴가가 유급 10일로 확대되었으니 사전에 확인하요 꼭 사용하세요!",
          },
        ],
      },
    },
    {
      week: 36,
      baby: {
        head: {
          title: "이제는 세상에 나오더라도 위험한 조산이 아니에요!",
          discribed: "아기 크기 : 커다란 밀짚모자만 한 크기에요!",
          size: "약 47~48cm (2.6~7kg)",
        },
        body: [
          {
            subTitle: "본격적으로 세상에 나올 준비를 해요!",
            discribed:
              "신체 기관은 완전히 성숙해서 태어날 시기만 결정하면 돼요.\n\n폐는 거의 성숙했지만 아직은 혼자 힘으로 호흡할 수 없어 이 시기에 태어나면 인공호흡기에 의존해야 해요.\n\n이제 마지막 한 달 동안 태아의 배내털은 거의 빠지게 되고, 어깨나 팔다리 혹은 몸의 주름진 곳에만 조금 남아요그리고 출산이 다가올수록 태아는 점차 머리를 골반 안으로 집어넣어몸이 고정되면서 태동이 줄어드는 느낌이 든답니다!",
          },
        ],
      },
      mom: {
        head: {
          title: "이제는 막달이에요!",
          discribed: "배가 커질만큼 커지고, 하강감이 느껴져요.",
        },
        body: [
          {
            subTitle: "몸무게가 최고치로 늘어나요!",
            discribed:
              "자궁은 최대한으로 커져 더 이상 공간이 없을 것 같은 느낌이 들어요.\n\n보통의 경우 몸무게는 11~14kg정도 늘어나 있고, 앞으로 분만일까지 아주 조금 늘거나 또는 전혀 늘지 않게 돼요.\n\n출산을 앞둔 엄마는 마음이 풀어져 체중관리에 소홀해 질 수 있어요.\n\n하지만 급격한 체중의 증가는 만성 고혈압과 같은 합병증을 유발하고, 자연분만을 어렵게 할 수도 있어요.\n\n마지막까지 방심하지 말고 체중관리에 집중합시다!",
          },
          {
            subTitle: "하강감이 느껴져요!",
            discribed:
              "출산이 가까워지면서 복부의 변화도 나타나요.\n\n배꼽에서 자궁 상부까지의 길이가 짧아지고 배가 아래로 내려간 듯한 느낌이 드는데, 태아의 머리가 산도로 들어가면서 생기는 현상이에요.\n\n태아가 하강하면 상복부에 공간적인 여유가 생겨 숨쉬기 편해지지만, 골반이나 방광에는 더 많은 압박이 가해져요.\n\n하강감은 임산부에 따라 출산 몇 주 전에 느껴지기도 하고 진통 중이나 진통이 진행될 때 태아가 산도로 내려가는 경우도 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "기나긴 마라톤의 결승선이 다가와요!",
          discribed: "이제 막달에 접어들었어요.",
        },
        body: [
          {
            subTitle: "막달임을 주변에 알리고 양해를 구해요!",
            discribed:
              "이제 진짜 막달에 접어들었어요.\n\n40주간의 기나긴 마라톤의 피니시라인이 코앞이에요!\n\n이제는 직장에 출산이 임박했다는 사실을 알리세요.\n\n이제 정말 막달이니 갑자기 진통이 시작되면 중간에 나가야 할 수도 있다고 미리 양해를 구하세요!\n\n출산시까지 재택 근무가 가능한지 확인하는 것도 하나의 방법이에요.",
          },
        ],
      },
    },
    {
      week: 37,
      baby: {
        head: {
          title: "태어날 준비를 끝내고 발육과정을 마무리해요!",
          discribed: "펭귄만 한 크기에요!",
          size: "약 49~50cm (2.8~9kg)",
        },
        body: [
          {
            subTitle: "태어날 준비, 완료!",
            discribed:
              "이제 태아는 태어날 준비를 거의 다 마쳤지만, 출산 때까지 남은 몇 주 동안에도 조금씩 성장하고 체중이 증가해요.\n\n그동안 피부를 보호하던 태지와 솜털을 벗어내고, 다른 분비물들과 함께 삼켜 태변으로 배출해요.\n\n태아의 머리크기에 따라 제왕절개 여부를 고려해야 해요.\n\n진통이 시작되기 전에 미리 결정하는 건 쉽지 않지만, 담당의 선생님과 상담을 통해최대한 엄마가 안전할 수 있는 분만 방법을 선택하는 것이 좋습니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "이제부터는 조산이 아니에요!",
          discribed: "언제든지 아기가 나올 수 있다는 사실을 명심하세요!",
        },
        body: [
          {
            subTitle: "이제부터는 모든 준비를 끝마쳐야 해요!",
            discribed:
              "모든 아기가 40주를 채우고 나오는건 아니에요.\n\n지금부터는 언제나올지 모르는 상황이에요.\n\n매주 정기검진을 하며 내진을 통해 아기가 얼마나 내려왔는지, 엄마의 골반과 자궁경부를 확인해요.",
          },
          {
            subTitle: "아랫배가 불규칙하게 당기거나 통증이 느껴져요!",
            discribed:
              "출산이 가까워지면서 때때로 아랫배가 당기고 통증이 느껴져요.\n\n혹시 진통이 시작된 것은 아닐까 하는 착각을 불러일으킬 정도예요.\n\n하지만 진통이 불규칙적이라면 이 통증은 진통의 시작이 아니라 몸이 출산 연습을 하고 있는 거라고 볼 수 있어요.\n\n하지만 진통이 규칙적으로 반복되면 출산이 시작된 것이므로 병원에 갈 준비를 해야 해요!",
          },
          {
            subTitle: "자궁구가 부드러워지고 점액 분비가 늘어나요! ",
            discribed:
              "출산이 가까워지면 자궁은 태아가 쉽게 빠져나올 수 있도록 입구가 축축해지면서 유연해지고 탄력성이 생겨요.\n\n이때는 자궁 분비물도 많아지므로 속옷을 자주 갈아입고 샤워를 자주 하는 것이 좋아요.\n\n임신부에 따라서는 간혹 자궁구가 미리 열리기도 하는데, 이럴 경우에는 안정을 취하면서 경과를 지켜보도록 해요.",
          },
          {
            subTitle: "아기가 언제 나올까요?",
            discribed:
              "의사 선생님은 엄마의 자궁 경부가 열린 정도를 통해 확인해요!\n\n아기가 통과하려면 자궁문이 10cm는 열려야 해요.\n\n자궁경부의 두께도 확인하는데, 두께가 얇아질수록 출산이 임박했다고 볼 수 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아내의 곁을 지키는 슈퍼맨!",
          discribed: "언제 시작될지 모를 출산을 대비해 남편이 옆에 있어주세요!",
        },
        body: [
          {
            subTitle: "항상 곁에 있어주세요!",
            discribed:
              "이제부터는 언제 출산이 시작될지 모르니 항상 아내의 곁을 지킬것!\n\n자리를 비울 땐 반드시 연락을 제때 확인해야해요.\n\n출산이 임박한 지금은 절대적인 안정이 필요하니 아내와 함께 차를 타고 장거리 이동은 금지예요.\n\n조금만 더 힘내요!",
          },
        ],
      },
    },
    {
      week: 38,
      baby: {
        head: {
          title: "대부분 예정일 2주 전후로 태어나요!",
          discribed: "멜로디언만 한 크기에요!",
          size: "약 50cm (3kg)",
        },
        body: [
          {
            subTitle: "태어날 준비, 완료!",
            discribed:
              "출산이 가까워지면서 태아가 골반 속으로 내려가기 때문에 태동이 줄어들어요.\n\n산모의 배에 귀를 대면 태아의 심박동이 들린답니다.\n\n태아는 규칙적인 수면리듬을 갖게되고 태반은 퇴화되어요.\n\n출산 직전 1주일 동안 태아의 부신으로부터 코티솔이라는 호르몬이 많이 분비되는데, 이 호르몬은 태아가 세상에 태어난 뒤 첫 호흡을 할 수 있도록 도와줘요.\n\n이외에 심장이나 간장, 소화 기관, 비뇨 기관 등이 완성되어 출산을 기다리고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "긴장을 늦출 수 없는 한주!",
          discribed: "예정일을 앞둔 지금, 철저하게 준비해요!",
        },
        body: [
          {
            subTitle: "출산가방 점검!",
            discribed:
              "미리 싸둔 출산가방을 점검해요!\n\n뺴놓은 건 없는지, 더 추가할 물건이 있진 않은지 꼼꼼히 확인해요.\n\n점검이 끝난 가방은 눈에 잘 띄는 곳에 보관합시다~",
          },
          {
            subTitle: "병원은 언제?",
            discribed:
              "5분 간격의 규칙적인 진통이 1시간이상 지속될경우, 간격에 상관없이 아주 강한 진통이 올 경우 병원에 가야해요.\n\n그밖에도 양수가 터지거나 출혈이 있으면 즉시 병원에 가야합니다.",
          },
          {
            subTitle: "진통은 얼마나 갈까요?",
            discribed:
              "초산의 경우 분만을 하는데 평균적으로 12시간 이상이 걸려요.\n\n그렇기 때문에 출산을 위해서 엄마의 튼튼한 체력이 필요해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠도 불안하지만, 더 불안해하고 있을 아내를 위해!",
          discribed: "곁을 지키며 아내가 안심할 수 있게 해주세요.",
        },
        body: [
          {
            subTitle: "출산을 코앞에 두고 불안해하는 아내에게...",
            discribed:
              "불안해하는 아내를 안심시켜주세요!\n\n항상 곁을 지키며 돌발 상황이 발생해도 남편이 있으니 걱정할 것이 없음을 상기시켜주세요.\n\n아내의 상태를 주의깊게 관찰하며, 언제라도 빠르게 대응 할 수 있는 마음가짐이 필요합니다.\n\n이제 곧 귀여운 아기가 세상에 나올거예요.\n\n얼마 남지 않은 둘만의 시간을 즐겨보세요!",
          },
        ],
      },
    },
    {
      week: 39,
      baby: {
        head: {
          title: "아기아 세상밖으로 나오기 가장 이상적인 시기!",
          discribed: "호박만 한 크기에요!",
          size: "약 50~51cm (3.2~3kg)",
        },
        body: [
          {
            subTitle: "태어날 준비, 완료!",
            discribed:
              "아기는 세상으로 나올 준비를 끝냈어요.\n\n이 시기에 정상적인 아기는 출산 후 체온을 유지하기 위해 여전히 지방층을 축적하고 있어요.\n\n태반에서 분비되는 호르몬으로 인해 성별에 관계없이 가슴이 부풀어 오르며, 출산 이후 곧 가라 앉아요.\n\n소리, 냄새, 빛, 촉감에 반응할 수 있을 만큼 전 영역에 걸쳐 반사작용을 할 수 있는 시기예요.",
          },
        ],
      },
      mom: {
        head: {
          title: "이제 아기를 만날 수 있어요!",
          discribed: "지금까지 잘해 온 엄마도 아기도 정말 대단해요.",
        },
        body: [
          {
            subTitle: "자궁 수축이 규칙적으로 일어나요!",
            discribed:
              "분만을 앞둔 자궁 경부는 더욱 부드러워지고, 자궁 수축은 규칙적으로 진행되면서 분만의 신호를 알려요.\n\n자궁 수축은 움직일 때마다 더 심해지는데, 간격이 일정하고 점점 좁아지면 병원에 가야해요.",
          },
          {
            subTitle: "분만을 알리는 신호!",
            discribed:
              "자궁 수축과 함께 분만을 알리는 신호는 양막이 파열되어 양수가 나오거나, 자궁 경관을 막고 있는 점액이 빠져나오면서 출혈이 생기는 거예요.\n\n이것을 이슬이라고 하는데, 이슬이 나오면 분만이 시작되는 것이기 때문에 빨리 병원으로 가야 해요.\n\n신후기에 약간 피가 비치는 것이 이슬인데, 이슬이 비친 후 며칠이나 몇 시간 후면 진통이 시작돼요.\n\n반면 양수가 터지면 물이 흐르는 것처럼 흘러요.\n\n선홍색 분비물이 계속 흐르거나 양수가 터진 느낌이 있다면 즉시 병원으로 가야 해요.",
          },
          {
            subTitle: "힘을 줘보세요!",
            discribed:
              "언제 어떻게 힘을 줘야 하는지는 분만대에 오른 뒤 의사의 지시대로 하면 되지만,이를 미리 알고 연습하면 훨씬 출산 시간을 단축할 수 있어요.\n\n다만 임신 중에는 실제로 힘주기 연습을 할 수 없기 때문에 그저 느낌으로 연습 할 수 밖에 없어요.\n\n우선 배변을 할 때의 이미지를 떠올려 보세요.\n\n아기를 밀어내는 느낌으로 항문이나 질 입구 부분을 향해 힘을 주어야 해요.\n\n특히 배 쪽이 아니라 엉덩이 쪽으로 힘을 주는 것이 포인트예요.\n\n힘주기 할 때의 자세는 치대 머리 위나 허리 옆부분에 있는 손잡이를 붙잡고 하거나, 허벅지를 두 팔로 고정시키고 발끝을 자유롭게 해서 하는 등 자신이 편한 쪽으로 선택하면 돼요.",
          },
        ],
      },
      dad: {
        head: {
          title: "막판 스퍼트, 힘내요 아빠!",
          discribed: "이제 곧 아기를 만날 수 있어요!",
        },
        body: [
          {
            subTitle: "결승선이 코앞에!",
            discribed:
              "이제 정말 출산이 코앞이에요.\n\n그동안엄마도, 아빠도 정말 고생 많았어요!\n\n생명의 탄생을 코앞에 둔 엄마의 기분이 많이 복잡할거예요.\n\n엄마의 감정 기복이 심해도 아빠가 이해해 주세요.\n\n지금껏 아빠도 너무 고생했지만 마지막까지 엄마를 위해 조금만 더 수고부탁드려요.\n\n엄마와 아기를 위하여, 화이팅!",
          },
        ],
      },
    },
    {
      week: 40,
      baby: {
        head: {
          title: "엄마, 아빠 보고싶었어요!",
          discribed: "아기 너구리만 한 크기에요!",
          size: "약 52cm (3.5kg)",
        },
        body: [
          {
            subTitle:
              "아기는 모든 준비를 마치고 엄마와 아빠를 만날 날을 기다리고 있어요!",
            discribed:
              "약 5%정도의 아기만이 출산예정일을 지킨다고 하니,예정일이 지났다고 하더라도 걱정보다는 넉넉한 마음으로 아기를 맞을 준비를 해요.\n\n아기는 태어나는 즉시 폐로 호흡하고, 본능적으로 엄마 젖을 빨며 울음소리로 자신의 의사를 전달해요.\n\n태변은 분만할 때 보는 태아도 있으며 출생해서 24시간 이내에 배설되게 돼요.\n\n탯줄은 1주일 정도 후에 떨어진답니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "바로 오늘, 감동의 순간!",
          discribed: "아기와의 첫 만남을 진심으로 축하합니다!",
        },
        body: [
          {
            subTitle: "10개월간의 긴 여정이 끝나가고 있어요!",
            discribed:
              "규칙적인 진통이 시작되면 마음의 준비를 하고 입원을 해요.\n\n출산의 고통은 이루 말할 수 없이 힘들지만, 이 또한 엄마가 되기 위한 과정이라 생각하고 끝까지 최선을 다하는 모습을 잃지 말아요.\n\n분만 예정일을 임신 40주 0일째 날로 볼 때 초산의 경우 예정일보다 조금 늦게 진통을 할 수 있어요출산 신호가 오면 허둥대지 말고 준비해둔 가방을 챙겨 병원으로 갈 수 있도록 해요.",
          },
          {
            subTitle: "가진통과 진진통",
            discribed:
              "초산인 경우 진통 시간이 길기 때문에 규칙적인 진통이 5~10분 간격으로 진행되면 입원하는 것이 좋아요.\n\n진통과 분만 양상은 사람마다 달라서, 진통 후 3시간 만에 출산하는 사람도 있는가 하면 1박 2일에 걸쳐 진통을 겪는 사람도 있어요.\n\n우선 진통이 시작된 것 같으면 진통 간격을 재어 병원에 연락하고,파수되거나 많은 양의 출혈이 있을 때는 신속하게 병원으로 이동해야 해요.",
          },
          {
            subTitle: "분만 과정",
            discribed:
              "실제 분만 과정은 자궁경부가 열리는 분만 제 1기, 아기가 나오기 시작하는 분만 제 2기, 태반이 분리되어 유출되는 분만 제 3기로 나누어 볼 수 있어요.\n\n초산모의 경우 분만 제1기부터 분만까지 소요시간은 약 9 ~ 19시간, 경산모의 경우는 약 6 ~ 14시간이 소요되지만 산모에 따라 편차가 커요.\n\n분만 제 2기는 경부가 완전히 열리고 아기가 태어나는 시기에요.\n\n보통 초산모는 1-3시간, 경산모는 30분 이내의 시간이 소요돼요.\n\n아기가 태어난 후 5 ~ 10분 뒤 자궁이 강하게 수축하면서 태반이 자궁에서 떨어져 나오는데, 이 시기를 분만 제 3기라고 해요.",
          },
          {
            subTitle: "긴 여정의 끝, 새로운 출발",
            discribed:
              "임신과 출산이라는40주간의 기나긴 마라톤을 완주했어요!\n\n무사히 완주한 엄마, 훌륭한 페이스메이커가 되어준 아빠, 모두 정말 수고 많았어요.\n\n이제 아기는 세상에 나올 준비를 마치고 엄마와 아빠의 품에 안길거예요.\n\n자 이제 엄마와 아빠 그리고 아기까지 함께하는 새로운 여정이 시작됩니다!\n\n새로운 여정으로 내딛는 첫 발걸음을 응원해요.\n\n모두의 앞날에 행복한 일만 가득하기를!",
          },
        ],
      },
      dad: {
        head: {
          title: "출산, 그 감동의 순간! 아빠도 함께해요!",
          discribed: "마지막까지 아내의 곁을 지켜주세요.",
        },
        body: [
          {
            subTitle: "진통 주기를 체크해요!",
            discribed:
              "아내의 진통이 시작되었다면 진통의 강도와 간격을 체크하여 기록해 주세요.\n\n아내는 지금 진통으로 정신이 없어 체크할 겨를이 없답니다.\n\n초산의 경우 5~10분간격일때가 병원에 가야하는 진통이에요.\n\n양수가 터진 경우에는 감염의 위험이 있기 때문에 대형 패드나 기저귀를 대고 빠르게 병원으로 이동해주세요.",
          },
          {
            subTitle: "아내의 곁을 지켜주세요!",
            discribed:
              "고통과 낯선 상황으로 고생하는 아내의 곁에서 함께 그 시간을 보내주세요.\n\n고통을 줄이기 위해 함께 연습했던 호흡법을 되새겨주고, 아내의 곁에 내가 있음을 알려 아내를 안심시켜주세요.",
          },
          {
            subTitle: "출산 후 아내의 상태를 가장 먼저 확인해주세요!",
            discribed:
              "탄생의 기쁨과 정신없는 상황속에서 출산을 하느라 고생한 아내의 상태를 살피는 것을 잊지 마세요.\n\n고생한 아내에게  위로의 말을 건네며 꼭 안아주세요.\n\n40주라는 시간동안 정말, 수고 많았어요!",
          },
        ],
      },
    },
  ],
};

export default singleBabyData;
